﻿/**
 * Slovenian locale messages
 * Mirrors the structure of the English source of truth
 */

import { brand } from '../config/brand';

export default {
  // Vremenske kontrole + okno (CurrentWeather, WeatherModal, WeatherForecast)
  weather: {
    title: 'Trenutno vreme',
    refresh: 'Osveži vreme',
    updated: 'Posodobljeno',
    justNow: 'pravkar',
    feelsLike: 'Občutek',
    humidity: 'Vlažnost',
    wind: 'Veter',
    pressure: 'Tlak',
    clouds: 'Oblaki',
    visibility: 'Vidljivost',
    sunrise: 'Sončni vzhod',
    sunset: 'Sončni zahod',
    hourlyForecast: 'Urna napoved',
    dailyForecast: 'Dnevna napoved',
    forecastTitle: 'Vremenska napoved',
    hourly: 'Urno',
    daily: 'Dnevno',
    today: 'Danes',
    tomorrow: 'Jutri',
    unavailable: 'Vremenski podatki še niso na voljo.',
    forecastUnavailable: 'Napoved ni na voljo.',
    rainPercent: '{count}% dežja',
    noRain: 'Brez dežja',
    configureInSettings: 'Nastavite vreme v nastavitvah',
    loadFailed: 'Vremenskih podatkov ni bilo mogoče naložiti',
    alertsTitle: 'Vremenska opozorila',
    now: 'Zdaj',
    scrub: 'Pomik po napovedi',
    sun: 'Sonce',
    moon: 'Luna',
    moonrise: 'Vzhod lune',
    moonset: 'Zahod lune',
    illumination: 'osvetljena',
    details: 'Podrobnosti',
  },
  // Dodajanje sob (AddRoomModal) - besedila vmesnika
  roomWizard: {
    addRooms: 'Dodaj sobe',
    buildingType: 'Vrsta stavbe',
    selectDefaults: 'Izberi privzete sobe za {type}',
    selectCommonRooms: 'Izberi običajne sobe',
    alreadyExists: 'Že obstaja',
    floor: 'Nadstropje {number}',
    addCustomRoom: 'Dodaj lastno sobo',
    roomName: 'Ime sobe',
    roomNamePlaceholder: 'npr. Gostinska soba, Vinska klet',
    floorNumber: 'Številka nadstropja',
    floorNumberPlaceholder: '0, 1, 2...',
    addCustomRoomButton: 'Dodaj lastno sobo k izbiri',
    areaAssignment: 'Dodelitev območja (neobvezno)',
    assignToArea: 'Dodeli območju',
    noArea: 'Brez območja',
    areaHelp: 'Vse izbrane sobe bodo dodeljene temu območju',
    selectedRooms: 'Izbrane sobe ({count})',
    clearAll: 'Počisti vse',
    cancel: 'Prekliči',
    creating: 'Ustvarjanje...',
    createOne: 'Ustvari {count} sobo',
    createMany: 'Ustvari {count} sob',
    searchIcons: 'Išči ikone',
  },
  // Dodajanje sob - vrste stavb in običajne sobe
  roomPresets: {
    buildingTypes: {
      allRooms: 'Vse sobe',
      home: 'Dom',
      house: 'Hiša',
      office: 'Pisarna',
      school: 'Šola',
      hotel: 'Hotel',
      hospital: 'Bolnišnica',
    },
    rooms: {
      entrance_hall: 'Veža',
      living_room: 'Dnevna',
      dining_room: 'Jedilnica',
      kitchen: 'Kuhinja',
      pantry: 'Shramba',
      family_room: 'Družinska',
      study: 'Delovna',
      home_office: 'Pisarna',
      library: 'Knjižnica',
      master_bedroom: 'Glavna spalnica',
      bedroom: 'Spalnica',
      bedroom_2: 'Spalnica 2',
      bedroom_3: 'Spalnica 3',
      bedroom_4: 'Spalnica 4',
      guest_bedroom: 'Gostinska spalnica',
      kids_room: 'Otroška',
      master_bathroom: 'Glavna kopalnica',
      bathroom: 'Kopalnica',
      powder_room: 'Stranišče',
      laundry: 'Pralnica',
      garage: 'Garaža',
      workshop: 'Delavnica',
      storage: 'Skladišče',
      utility_room: 'Tehnika',
      basement: 'Klet',
      wine_cellar: 'Vinska klet',
      home_theater: 'Domači kino',
      game_room: 'Igralnica',
      gym: 'Telovadnica',
      patio: 'Terasa',
      balcony: 'Balkon',
      terrace: 'Streha',
      garden: 'Vrt',
      pool_area: 'Bazen',
      hallway: 'Hodnik',
      attic: 'Podstrešje',
      reception: 'Recepcija',
      office: 'Pisarna',
      meeting_room: 'Seja soba',
      conference_room: 'Konferenčna soba',
      break_room: 'Počivalnica',
      restroom: 'Stranišče',
      server_room: 'Strežniška soba',
      classroom: 'Učilnica',
      cafeteria: 'Menza',
      gymnasium: 'Telovadnica',
      laboratory: 'Laboratorij',
      playground: 'Igrišče',
      lobby: 'Avla',
      guest_room: 'Gostinska soba',
      suite: 'Apartma',
      restaurant: 'Restavracija',
    },
  },
  // Common UI elements - buttons, actions, generic labels
  common: {
    save: 'Shrani',
    cancel: 'Prekliči',
    delete: 'Izbriši',
    remove: 'Odstrani',
    close: 'Zapri',
    back: 'Nazaj',
    confirm: 'Potrdi',
    ok: 'V redu',
    loading: 'Nalaganje...',
    saving: 'Shranjevanje...',
    error: 'Napaka',
    more: 'Več',
    copy: 'Kopiraj',
    all: 'Vsi',
    language: 'Jezik',
  },

  // Besedila dialogov / sporočilnih oken (potrditev, opozorilo, toast)
  dialogs: {
    // Splošno
    areYouSure: 'Ali ste prepričani?',
    typeDelete: 'Vnesite »DELETE«',
    finalWarning: 'ZADNJE OPOZORILO. Vsi podatki bodo izbrisani. Nadaljujte?',
    done: 'Opravljeno',
    errorWithMessage: 'Napaka: {message}',
    saveFailed: 'Shranjevanje sprememb ni uspelo',
    validationErrors: 'Odpravite naslednje napake:\n{errors}',
    deleteAllConversationHistory:
      'Ali res želite izbrisati celotno zgodovino pogovora? Tega dejanja ni mogoče razveljaviti.',
    unregisterFromCloud: 'Odjava iz oblaka? Oddaljeni dostop bo onemogočen.',
    removeUserAccess: 'Odstraniti dostop tega uporabnika?',
    allDevicesDeleted: 'Vse naprave izbrisane',
    allRoomsDeleted: 'Vse sobe izbrisane',
    allIntegrationsDeleted: 'Vse integracije izbrisane',
    allScenesDeleted: 'Vse scene izbrisane',
    factoryResetInitiated: 'Tovarniška ponastavitev je bila sprožena.',
    // Naprava
    deviceDeleteConfirm: 'Ali res želite izbrisati »{name}«?\n\nTega dejanja ni mogoče razveljaviti.',
    deviceDeleteConfirmShort: 'Ali res želite izbrisati to napravo?',
    deviceRemoveConfirm: 'Ali res želite odstraniti to napravo?',
    deviceDeleteFailed: 'Izbris naprave ni uspel',
    devicesDeleteFailed: 'Izbris naprav ni uspel',
    deviceDeleteFailedMessage: 'Izbris naprave ni uspel: {message}',
    deviceDuplicateFailed: 'Podvajanje naprave ni uspelo: {message}',
    deviceReorderFailed: 'Posodabljanje vrstnega reda naprav ni uspelo',
    deviceReinitConfirm:
      'To bo izbrisalo in znova ustvarilo vse vrednosti naprave glede na definicijo vrste naprave. Vrednosti, ki jih je ustvaril uporabnik, bodo ohranjene. Reference (KNX naslovi, Matter preslikave) bodo izgubljene in jih bo treba znova konfigurirati. Nadaljujte?',
    deviceReinitFailed: 'Znova inicializacija vrednosti naprave ni uspela',
    deviceRefsSaveFailed: 'Shranjevanje referenc ni uspelo',
    deviceRefsUpdateFailed: 'Nekaterih referenc ni bilo mogoče posodobiti:\n{errors}',
    customValueDeleteConfirm: 'Izbrisati po meri vrednost »{name}«?',
    thumbnailUploadFailed: 'Nalaganje slike naprave ni uspelo: {message}',
    thumbnailRemoveFailed: 'Brisanje slike naprave ni uspelo: {message}',
    stateThumbnailUploadFailed: 'Nalaganje slike stanja ni uspelo: {message}',
    stateThumbnailRemoveFailed: 'Brisanje slike stanja ni uspelo: {message}',
    deviceRoomUpdateFailed: 'Posodabljanje sobe ni uspelo: {message}',
    // Widget / nadzorna plošča
    widgetDeleteConfirm: 'Ali res želite izbrisati ta widget?',
    widgetMissing: 'Ta widget ne obstaja več. Morda je bil odstranjen. Seznam widgetov se bo osvežil.',
    widgetSaveFailed: 'Shranjevanje ni uspelo: {message}',
    widgetRemoveConfirm: 'Odstraniti ta widget z nadzorne plošče?',
    dashboardRebuildConfirm: 'Znova zgraditi »{name}« kot {label}? Obstoječi widgeti na tej strani bodo zamenjani.',
    dashboardDeleteConfirm: 'Izbrisati »{name}«? Tega dejanja ni mogoče razveljaviti.',
    dashboardGroupDeleteConfirm: 'Izbrisati skupino »{name}«? Strani v tej skupini bodo odzdružene.',
    dashboardGroupDeleteCountConfirm: 'Izbrisati skupino »{name}«? {count} stran(i) bo odzdruženih.',
    // Soba
    roomExistsInDb: 'Soba »{name}« že obstaja v podatkovni zbirki.',
    roomAlreadyInSelection: 'Soba »{name}« je že v vašem izboru.',
    roomsCreateFailed: 'Ustvarjanje sob ni uspelo',
    roomUpdateFailed: 'Posodabljanje sobe ni uspelo',
    // Scena
    sceneCreateFailed: 'Ustvarjanje scene ni uspelo',
    sceneDeleteFailed: 'Brisanje scene ni uspelo',
    sceneValuesSaveFailed: 'Shranjevanje vrednosti scene ni uspelo',
    sceneThumbnailUploadFailed: 'Nalaganje sličice ni uspelo',
    // Avtomatizacija
    automationCreateFailed: 'Funkcije ni bilo mogoče ustvariti',
    automationSaveFailed: 'Funkcije ni bilo mogoče shraniti',
    automationDeleteConfirm: 'Ali res želite izbrisati »{name}«?',
    automationDeleteFailed: 'Funkcije ni bilo mogoče izbrisati',
    automationDeleteFailedRetry: 'Funkcije ni bilo mogoče izbrisati. Poskusite znova.',
    // Koledar
    calendarDeleteConfirm: 'Izbrisati »{name}« in vse njegove dogodke?',
    calendarSaveChanges: 'Ali želite shraniti spremembe?',
    calendarDiscardChanges: 'Zavreči neshranjene spremembe?',
    calendarDeleteEvent: 'Izbrisati »{title}«?',
    // Kamera / integracija
    cameraDeleteRecording: 'Izbrisati ta posnetek? Vsi segmenti bodo trajno odstranjeni.',
    cameraDeleteRecordingEvent: 'Izbrisati ta dogodek posnetka? Vsi segmenti bodo trajno izbrisani.',
    cameraDeleteConfirm: 'Izbrisati kamero »{name}«? Vsi posnetki bodo trajno izbrisani.',
    cameraDeleteAllRecordings: 'Izbrisati VSE posnetke za »{name}«? Tega dejanja ni mogoče razveljaviti.',
    cameraResetSettings: 'Ponastaviti vse nastavitve pretakanja na privzete?',
    cameraToggleFailed: 'Preklapljanje integracije ni uspelo: {message}',
    cameraNameSaveFailed: 'Shranjevanje imena ni uspelo: {message}',
    cameraSettingsSaved: 'Nastavitve kamere uspešno shranjene',
    cameraSettingsSaveFailed: 'Shranjevanje nastavitev kamere ni uspelo: {message}',
    integrationConfigSaveFailed: 'Shranjevanje konfiguracije ni uspelo: {message}',
    knxNoInterfaces:
      'V omrežju ni najdenih KNX IP vmesnikov. Prepričajte se, da je vaš KNX IP vmesnik vklopljen in povezan.',
    discoveryFailed: 'Odkrivanje ni uspelo: {message}',
    devicesAddFailed: 'Dodajanje nekaterih naprav ni uspelo: {message}',
    // Galerija / slike
    imageDeleteConfirm: 'Ali res želite izbrisati to sliko?',
    imageDeleteForEntity: 'Izbrisati sliko vrste {type} za {entity}?',
    imageReplaceForEntity: 'Zamenjati sliko vrste {type} za {entity}?',
    fileTooLarge: 'Datoteka je prevelika (največ 50 MB)',
    fileDeleteConfirm: 'Izbrisati »{name}«?',
    fileDeleteFailed: 'Brisanje ni uspelo',
    albumAddFailed: 'Dodajanje v album ni uspelo',
    albumRemoveFailed: 'Odstranjevanje iz albuma ni uspelo',
    albumSaveFailed: 'Shranjevanje albuma ni uspelo',
    albumDeleteConfirm: 'Izbrisati album »{name}«? Fotografije ne bodo izbrisane.',
    albumDeleteFailed: 'Brisanje albuma ni uspelo',
    // Mediji / zapiski
    mediaDeleteConfirm: 'Izbrisati »{title}« iz medijske knjižnice? To odstrani tudi datoteko s strežnika.',
    playlistDeleteConfirm: 'Izbrisati ta seznam predvajanja?',
    zoneDeleteConfirm: 'Izbrisati to cono? Predvajanje se bo ustavilo in vsi člani bodo odstranjeni.',
    mediaPlayerRemoveConfirm: 'Odstraniti ta medijski predvajalnik?',
    coverPhotoUploadFailed: 'Nalaganje naslovne fotografije ni uspelo',
    coverPhotoRemoveConfirm: 'Odstraniti to naslovno fotografijo?',
    coverPhotoRemoveFailed: 'Odstranjevanje naslovne fotografije ni uspelo',
    noteSaveFailed: 'Shranjevanje zapiska ni uspelo',
    noteDeleteConfirm: 'Izbrisati ta zapisek in vse njegove slike?',
    noteDeleteFailed: 'Brisanje zapiska ni uspelo',
    // Agent
    agentClearConversation: 'Počistiti ta pogovor?',
    logoutConfirm: 'Ali res želite odjaviti?',
    reminderDeleteConfirm: 'Izbrisati ta opomnik?',
    // Nakupovanje
    shoppingListSaveFailed: 'Shranjevanje seznama ni uspelo',
    shoppingListDeleteConfirm: 'Izbrisati ta seznam in vse njegove predmete?',
    shoppingListDeleteFailed: 'Brisanje seznama ni uspelo',
    shoppingItemAddFailed: 'Dodajanje predmeta ni uspelo',
    shoppingClearCheckedConfirm: 'Odstraniti vse označene predmete?',
    shoppingClearFailed: 'Počistiti predmete ni uspelo',
    shoppingStoreAddFailed: 'Dodajanje trgovine ni uspelo',
    shoppingStoreDeleteConfirm: 'Izbrisati to trgovino? Seznami bodo ostali, vendar bodo izgubili povezavo s trgovino.',
    shoppingStoreDeleteFailed: 'Brisanje trgovine ni uspelo',
    // Integracija (Matter / Z-Wave / Zigbee / nadzor)
    monitoringStartFailed: 'Zagon nadzora ni uspel: {message}',
    monitorWriteFailed: 'Pisanje ni uspelo: {message}',
    monitorReadFailed: 'Branje ni uspelo: {message}',
    mqttPropertyDeleteConfirm: 'Izbrisati to MQTT lastnost? Obstoječe reference naprav bodo odstranjene.',
    modbusRegisterDeleteConfirm: 'Izbrisati ta Modbus register? Obstoječe reference naprav bodo odstranjene.',
    knxDatapointDeleteConfirm: 'Izbrisati ta KNX skupinski naslov? Obstoječe reference naprav bodo odstranjene.',
    commissioningWindowFailed: 'Odpiranje okna za komisioniranje ni uspelo',
    matterDeviceUpdateFailed: 'Posodabljanje naprave ni uspelo',
    matterDeviceSaveFailed: 'Shranjevanje naprave ni uspelo',
    matterDeleteFailed: 'Brisanje ni uspelo',
    matterError: '❌ Napaka: {message}',
    matterReinterviewConfirm:
      'Znova razgovor z vozliščem {id}? To bo izbrisalo in znova ustvarilo vse naprave tega vozlišča.',
    matterDecommissioned: '✅ Vozlišče Matter uspešno odstranjeno in izbrisano',
    matterNodeDeleteError: '❌ Napaka pri brisanju vozlišča: {message}',
    matterNodeRemoveTitle: 'Odstrani vozlišče Matter',
    matterNodeRemoveInspecting: 'Preverjam vozlišče …',
    matterNodeRemoveDecommission: 'Krmilnik to vozlišče še ima — najprej bo razveljavljeno, nato bodo odstranjene njegove vrstice.',
    matterNodeRemoveGhost: 'Krmilnik tega vozlišča nima (shramba je bila ponastavljena ali pa je bilo vozlišče dodano v drug fabric). Njegove vrstice bodo izbrisane brez klica krmilnika.',
    matterNodeRemovePruneCounts: 'Vrstice za odstranitev: {endpoints} končnih točk, {clusters} gruč, {properties} vrstic z atributi.',
    matterNodeRemoveControllerOffline: 'Krmilnik Matter ne teče, zato ni mogoče ugotoviti, ali je vozlišče treba razveljaviti ali samo izbrisati. Najprej zaženite to integracijo — hub zavrača brisanje vrstic, ki jih ne more preveriti.',
    matterNodeRemoveDevicesFlag: 'Izbriši tudi {count} naprav, ustvarjenih iz tega vozlišča (seznam spodaj)',
    matterNodeRemoveDetach: '{count} naprav iz druge integracije bo s tega vozlišča samo odklopljenih, ne izbrisanih.',
    matterNodeRemoveOtherIntegration: 'druga integracija',
    matterNodeRemoveConfirm: 'Odstrani vozlišče',
    matterNodeRemoving: 'Odstranjujem …',
    matterNodeRemoved: '✅ Vozlišče odstranjeno — {endpoints} končnih točk, {clusters} gruč, {properties} vrstic z atributi, {devices} naprav.',
    matterNodeGhostHint: 'Ni v krmilniku Matter — tega vozlišča ni mogoče upravljati.',
    matterNodeRemoveAction: 'Odstrani',
    matterDiagnosticsFailed: 'Pridobivanje diagnostike ni uspelo: {message}',
    matterFabricResetConfirm:
      '⚠️ Ponastaviti Matter fabric?\n\nTo bo:\n- Izbrisalo vso shrambo in poverilnice Matter\n- Ustvarilo nov ID fabrica\n- Odstranilo vse komisionirane naprave\n- Zahtevalo ponovno komisioniranje vseh naprav\n\nTega dejanja NI mogoče razveljaviti. Nadaljujte?',
    matterFabricResetSuccess:
      '✅ Ponastavitev fabrica uspešna!\n\nKrmilnik Matter se bo znova zagnal z novim ID-jem fabrica.\nPo nekaj sekundah osvežite stran.',
    matterFabricResetFailed: '❌ Ponastavitev fabrica ni uspela: {message}',
    factoryResetFailed: 'Tovarniška ponastavitev ni uspela',
    matterDeviceRemoveFailed: 'Odstranjevanje naprave ni uspelo',
    threadSaveFailed: 'Shranjevanje nabora podatkov Thread ni uspelo. Funkcija na vozlišču morda še ni implementirana.',
    zigbeeGroupDeleteConfirm: 'Izbrisati skupino {id}?',
    remoteSupportEndSessionFailed: 'Končanje seje ni uspelo',
    remoteSupportSendMessageFailed: 'Pošiljanje sporočila ni uspelo',
    zigbeeNodeRemoveConfirm: 'Odstraniti vozlišče {id}?',
    zwaveNodeRemoveConfirm: 'Odstraniti vozlišče {id} iz podatkovne zbirke?',
    zwaveNodeRenameFailed: 'Preimenovanje vozlišča ni uspelo',
    zwaveEndpointRenameFailed: 'Preimenovanje končne točke ni uspelo',
    wifiSaveFailed: 'Shranjevanje WiFi poverilnic ni uspelo. Funkcija na vozlišču morda še ni implementirana.',
    touchPanelUnpairConfirm: 'Prekiniti povezavo z »{name}«? Napravo bo treba znova seznaniti.',
    mapZoneDeleteConfirm: 'Izbrisati cono »{name}«?',
    securityPinRemoveConfirm: 'Odstraniti PIN za skrivne naprave? Skrivne kamere bodo dostopne brez PIN-a.',
    // Nastavitve
    scheduleEditorComingSoon:
      'Urejevalnik urnikov kmalu na voljo. Urnike naprav konfigurirajte prek API-ja ali strani Energija.',
    libraryDeleteConfirm: 'Izbrisati ta element?',
    securityModeDeleteConfirm: 'Izbrisati ta varnostni način? Tega dejanja ni mogoče razveljaviti.',
    remoteSupportRemoveUserFailed: 'Odstranjevanje uporabnika ni uspelo',
    remoteSupportUpdateAccessFailed: 'Posodabljanje dostopa ni uspelo',
    // Uporabnik
    userSaveFailed: 'Shranjevanje uporabnika ni uspelo',
    userDeleteFailed: 'Brisanje uporabnika ni uspelo: {message}',
    profilePictureRemoveConfirm: 'Ali res želite odstraniti svojo profilno fotografijo?',
    // Strežniki
    serverRemoveFromCloud: `Odstraniti »{hub}« iz ${brand.agentName} Cloud?\n\nOpozorila:\n- Vnosi skupnega dostopa za ta strežnik bodo izbrisani.\n- Lokalni strežnik ${brand.agentName} bo še naprej deloval.\n- Da se znova pojavi v oblaku, se mora strežnik znova povezati in registrirati.\n\nTega dejanja ni mogoče razveljaviti.`,
    // Urejevalnik
    imageUrlMissing: 'Nalaganje je uspelo, vendar URL slike ni bil vrnjen.',
    imageUploadFailed: 'Nalaganje slike ni uspelo',
  },

  // Authentication
  auth: {
    signIn: 'Prijava',
    emailAddress: 'E-poštni naslov',
    passwordPlaceholder: 'Vnesite geslo',
    signInToYourHub: 'Prijavite se v svoje vozlišče',
    signInToOttoHome: `Prijava v ${brand.platformCompact}`,
    signingIn: 'Prijavljanje...',
    invalidCredentials: 'Neveljaven e-poštni naslov ali geslo',
    // No "Forgot password?" link on the sign-in form: the hub serves no
    // forgot/reset route any more (PLAN.md §4 phase 4, hub commit 51677c7),
    // so this sentence is the whole answer the form can honestly give.
    noPasswordReset:
      'Ponastavitve gesla ni: to vozli\u0161\u010de dodeljuje dostop s povabilom, ne po e-po\u0161ti. Prosite skrbnika za povabilo ali pove\u017eite to napravo iz aplikacije.',
    // The demo house's guest door: a way to see the product for anyone who has
    // nothing to sign in with yet — no account, just a name.
    tryLiveDemo: 'Vstopite v demo hi\u0161o',
    // Vozlišče je zavrnilo poverilnico te naprave (preklicana ali ji je potekla
    // vezava): `stores/auth.ts` → `notifyDeviceCredentialRejected` to pove enkrat,
    // nazaj pa vodi prijava — z računom ali z lokalnim geslom tega vozlišča.
    credentialRejected:
      'To vozli\u0161\u010de ne sprejema ve\u010d povezave te naprave. Prijavite se znova — z ra\u010dunom {platform} ali z lokalnim geslom tega vozli\u0161\u010da — in jo znova pove\u017eite.',
    genericError: 'Prišlo je do napake. Poskusite znova.',
    secureSmartHome: 'Varen dostop do vašega pametnega doma',
    usernameOrEmail: 'Uporabniško ime ali e-pošta',
    setupSystemNamePlaceholder: 'npr. Moj dom',
    setupUploadImage: 'Naloži sliko',
    setupNext: 'Naprej',
    setupBack: 'Nazaj',
    setupFinish: 'Dokončaj',
    setupSkip: 'Preskoči',
    setupCloudPricing: 'Cenik',
    setupCloudRegistered: 'Registrirano v oblaku',

    // Prevzem identitete iz oblaka (`POST /auth/claim`, PLAN.md F13): aplikacija
    // poveže to vozlišče s prijavljenim računom Torik, namesto da bi prevzela
    // prvega skrbnika vozlišča. Napaka tukaj je slepa ulica za uporabnika.
    claim: {
      noMatchingUser: 'Vaš račun Torik še ni nastavljen v tem vozlišču. Prosite skrbnika, da povabi {email}.',
      userDisabled: 'Ta račun je v tem vozlišču onemogočen. Prosite skrbnika, da ga omogoči.',
      invalidCloudToken: 'Vaše prijave v Torik ni bilo mogoče preveriti. Prijavite se znova.',
      failed: 'Tega vozlišča ni bilo mogoče povezati z vašim računom Torik. Za pomoč prosite skrbnika.',
    },

    // Uvodna prijava — poti v vozlišče brez gesla (PLAN.md §3.3). Katera se
    // prikaže, določa način delovanja v `src/config/onboarding.ts`.
    onboarding: {
      themeLight: 'Preklopi na svetli način',
      themeDark: 'Preklopi na temni način',
      redirecting: 'Preusmerjanje na prijavo ...',
      redirectingButton: 'Preusmerjanje ...',
      cloudSignIn: 'Prijavite se z računom {platform}',
      cloudWebIntro: 'Prijavite se s spletnim računom {platform} in dostopajte do svojih strežnikov.',
      joinTitle: 'Načini prijave',
      joinBody:
        'Vozlišča Torik se odprejo s svojim računom Torik ali z lokalnim geslom, ki ga vozlišče preveri samo. Monter se poveže s kodo, ki mu jo izda skrbnik.',
      joinInviteHint: 'Ste prejeli povabilo? Prijavite se s svojim računom Torik — strežnik bo tam.',
      // Vozliščevo lastno **lokalno geslo** (odločitev D1,
      // `docs/plans/LOCAL-HTTP-AND-CLOUD-ADOPTION.md`; vozlišče `t_7fb9c250`,
      // aplikacija `services/hubLocalPassword.ts`): vrata, ki jih ima oseba ob
      // krmilniku tudi takrat, ko v hiši ni interneta. Na voljo le na površini,
      // ki jo streže vozlišče samo (`config/onboarding.ts` → `localPassword`);
      // aplikacija in namizje prideta do istih vrat prek strani Lokalni
      // strežniki, zato jih ta zaslon tam ne ponavlja.
      localPasswordOpen: 'Prijavite se z lokalnim geslom',
      localPasswordTitle: 'Prijava z lokalnim geslom',
      localPasswordHint:
        'To geslo se preveri tukaj, na tem vozlišču — brez interneta. To je pot v vozlišče, ko je hiša brez povezave.',
      localPasswordIdentifierLabel: 'Vaše uporabniško ime v vozlišču ali e-pošta računa',
      localPasswordIdentifierPlaceholder: 'npr. tadej',
      localPasswordLabel: 'Lokalno geslo',
      // Tveganje R5 iz načrta: prva skrivnost tega vozlišča, ki jo je mogoče
      // preveriti brez povezave, zato površina jasno pove, kaj zanjo ne obstaja.
      localPasswordNoRecovery: 'Tega gesla ne more povrniti nič brez vašega računa Torik.',
      scanHubCode: 'Skenirajte kodo QR na vozlišču',
      scanHint: 'Uperite kamero v kodo QR, natisnjeno na nalepki vozlišča.',
      cameraDenied: 'Kamere ni bilo mogoče zagnati. Dovolite dostop do kamere in poskusite znova.',
      cameraUnsupported: 'Ta brskalnik ne zna brati kod QR. Uporabite aplikacijo Torik.',
      notAHubCode: 'To ni nalepka vozlišča. Skenirajte kodo QR, natisnjeno na vozlišču.',
      localServer: 'Poveži se z lokalnim strežnikom',
      localServerHint: 'Poiščite vozlišča Torik v tem omrežju.',
      searchingNetwork: 'Preiskovanje omrežja ...',
      networkHubs: 'Vozlišča v tem omrežju',
      noHubsFound: 'V tem omrežju ni najdenih vozlišč.',
      // Najdeno vozlišče, kot ga bere odločitvena tabela
      // (`resolveDiscoveredHubPlan`): vozlišče, za katero ima ta naprava
      // poverilnico, se odpre; tisto, za katero je nima, se pridruži; in
      // različica, prestara za `GET /api/hub/identity`, je še vedno na seznamu —
      // le povedano je, kaj je.
      hubJoinHint: 'Pridruži se temu vozlišču',
      hubOpenHint: 'Ta naprava je tu že nastavljena',
      hubNotIdentified: 'Ni se predstavilo (starejša programska oprema)',
      rescan: 'Išči znova',
      manualEntry: 'Vnesite naslov',
      ipPlaceholder: 'Naslov IP',
      portPlaceholder: 'Vrata',
      connect: 'Poveži',
      hubNotReachable: 'Ta naslov se ni odzval. Preverite naslov IP in vrata.',
      back: 'Nazaj',
      legacyNotice: 'Skrbniška rezervna prijava — to vozlišče prehaja na prijavo brez krajevnega gesla.',
    },
  },

  // Vgradnja naprav je končana zgodba (kartica `t_2f0c4a91`): kode ne izdaja,
  // vnaša in skenira nihče več. V tem imenskem prostoru ostaja le tisto, kar
  // drugi moduli berejo z dobesedno ključno besedo — ime vozlišča, kadar ga
  // aplikacija ne pozna (`enroll.hub.unknown`) in vloga, ki jo nosi seja
  // (`enroll.session.*`; `utils/sessionRole.ts`).
  enroll: {
    hub: {
      unknown: 'To vozlišče',
    },

    /** Kaj vloga pomeni v seji (`utils/sessionRole.ts`). */
    session: {
      roleLabel: 'V tem vozlišču deluje kot {role}.',
      validUntil: 'Poverilnica velja do {date}',
      roleOwner: 'lastnik',
      roleAdmin: 'skrbnik',
      roleResident: 'stanovalec',
      roleGuest: 'gost',
      roleService: 'servisni račun',
      roleInstaller: 'monter',
      roleViewer: 'gledalec',
      roleUnknown: 'naprava',
      continue: 'Nadaljuj v aplikacijo',
    },
  },

  // Navigation & Sidebar
  nav: {
    dashboard: 'Nadzorna plošča',
    home: 'Dom',
    rooms: 'Prostori',
    devices: 'Naprave',
    cameras: 'Kamere',
    security: 'Varnost',
    climate: 'Klima',
    water: 'Voda',
    appliances: 'Aparati',
    wellness: 'Dobro počutje',
    lights: 'Luči',
    shades: 'Senčila',
    energy: 'Energija',
    weather: 'Vreme',
    settings: 'Nastavitve',
    maintenance: 'Vzdrževanje',
    apps: 'Aplikacije',
    main: 'Glavno',
    media: 'Mediji',
    intercom: 'Interkom',
    map: 'Zemljevid',
  },

  roomsNav: {
    allRooms: 'Vsi prostori',
    unassigned: 'Nedodeljeno',
  },

  // Settings & System
  settings: {
    settingsUpdates: {
      hubUpdateTitle: 'Na voljo je posodobitev vozlišča',
      hubUpdateBody:
        'Na voljo je nova posodobitev vozlišča: v{version}. Odprite Nastavitve → Sistem → Posodobitev naprave, da jo namestite.',
      checkUpdates: 'Preveri posodobitve',
      checking: 'Preverjanje...',
      updateFailed: 'Posodobitev ni uspela',
      downloadingUpdate: 'Prenašanje posodobitve...',
      updateReady: 'Posodobitev pripravljena — znova zaženi za namestitev',
      restartInstall: 'Znova zaženi in namesti',
      upToDate: 'Uporabljate najnovejšo različico',
      appUpdate: 'Posodobitev aplikacije',
      checkFailed: 'Preverjanje posodobitev ni uspelo',
    },
    // Addon service cards (settings/AddonServicesSection.vue): the voice
    // services and the browser & automation addon the hub runs as containers.
    addons: {
      services: 'Storitve',
      refresh: 'Osveži',
      noServices: 'Ni razpoložljivih storitev.',
      status: {
        running: 'Deluje',
        stopped: 'Ustavljeno',
        notInstalled: 'Ni nameščeno',
        installing: 'Nameščanje',
        updating: 'Posodabljanje',
        uninstalling: 'Odstranjevanje',
        error: 'Napaka',
      },
      start: 'Zaženi',
      stop: 'Ustavi',
      install: 'Namesti',
      logs: 'Dnevniki',
      logsTitle: 'Dnevniki (zadnjih 100 vrstic)',
      generateFromDevices: 'Ustvari iz naprav',
      generating: 'Ustvarjanje...',
      availableCommands: 'Razpoložljivi ukazi',
      saveRestart: 'Shrani in znova zaženi',
      savingRestart: 'Shranjevanje in ponovni zagon...',
      savedRestarting: 'Shranjeno — vsebnik se znova zažene',
      errorPrefix: 'Napaka:',
      errorLoad: 'Storitev ni bilo mogoče naložiti',
      errorSaving: 'Napaka pri shranjevanju nastavitev',
      errorStart: 'Storitve ni bilo mogoče zagnati',
      errorStop: 'Storitve ni bilo mogoče ustaviti',
      errorInstall: 'Storitve ni bilo mogoče namestiti',
    },
  },

  // Settings Sidebar Navigation
  settingsNav: {
    configuration: 'Konfiguracija',
    general: 'Splošno',
    torikApi: 'Torik API',
    automations: 'Avtomatizacije',
    rooms: 'Prostori',
    devices: 'Naprave',
    functions: 'Funkcije',
    modes: 'Načini',
    integrations: 'Integracije',
    security: 'Varnost',
    energy: 'Energija',
    weather: 'Vreme',
    climate: 'Klima',
    water: 'Voda',
    appliances: 'Aparati',
    lights: 'Luči',
    shades: 'Senčila',
    scenes: 'Scene',
    routines: 'Rutine',
    charts: 'Grafikoni',
    system: 'Sistem',
    users: 'Uporabniki',
    presence: 'Slednje prisotnosti',
    agent: 'Agent',
    demo: 'Demo',
    backup: 'Varnostna kopija',
    library: 'Knjižnica',
    dashboards: 'Nadzorne plošče',
    gallery: 'Galerija',
    model: '3D model',
    installer: 'Monter',
    logs: 'Dnevniki',
    dangerZone: 'Nevarna cona',
  },

  installOffer: {
    text: 'Prenesite aplikacijo Torik — na telefonu je še boljša.',
    button: 'Namesti',
    dismiss: 'Ne zdaj',
  },

  // Views - Nested object for all view sections
  views: {
    // Map view (views/Map.vue + components/map/MapZonePanel.vue): the hub's own
    // geofence zones and the cloud areas the cloud owns (card `t_6b57f8f2`, plan
    // docs/plans/GEOFENCING-E2E.md §2.4). `cloudRefusal*` are read indirectly
    // (`cloudAreaRefusalNotice(...).key`) — see locales/localeAudit.ts.
    map: {
      title: 'Cone in območja',
      empty: 'Ni še nobene cone. Ustvarite jo z gumbom »Dodaj cono«.',
      radiusMeters: 'polmer {meters} m',
      flyTo: 'Pojdi na cono',
      editZone: 'Uredi cono',
      deleteZone: 'Izbriši cono',
      zoneName: 'Ime cone',
      radiusShort: 'Polmer (m)',
      radiusMetersLabel: 'Polmer (metri)',
      lat: 'Širina',
      lon: 'Dolžina',
      newZone: 'Nova cona',
      globalZone: 'Globalna cona (vidna vsem uporabnikom)',
      createZone: 'Ustvari cono',
      clickHint: 'Kliknite na zemljevid, da ustvarite novo cono',
      addZone: 'Dodaj cono',
      moveHint: 'Izberite območje in povlecite ročico, da ga premaknete',
      layerUsers: 'Uporabniki',
      layerZones: 'Cone',
      centerOnHub: 'Sredini na vozlišče',
      manageZones: 'Upravljaj cone',
      hubMarker: 'Vozlišče',
      sourceLocal: 'Na tem strežniku',
      sourceCloud: 'Območje v oblaku',
      cloudManaged: 'Upravljano v oblaku',
      cloudTitle: 'Območja v oblaku',
      cloudAdd: 'Dodaj območje v oblaku',
      cloudPickHint: 'Kliknite na zemljevid, da postavite novo območje v oblaku',
      cloudLoading: 'Nalaganje območij v oblaku…',
      cloudEmpty: 'Ni še nobenega območja v oblaku.',
      cloudRetry: 'Poskusi znova',
      cloudAdminOnly: 'Območja v oblaku lahko spreminja le lastnik ali skrbnik strežnika.',
      cloudAreaName: 'Ime območja',
      cloudCreate: 'Ustvari območje',
      cloudDeleteConfirm: 'Izbrisati območje v oblaku »{name}«?',
      cloudRefusalForbidden: 'Ta račun ne sme spreminjati območij v oblaku tega strežnika.',
      cloudRefusalNotMember: 'Ta račun nima vloge na tem strežniku.',
      cloudRefusalNotAdmin: 'Območja v oblaku lahko spreminja le lastnik ali skrbnik strežnika.',
      cloudRefusalNotFound: 'To območje v oblaku ne obstaja več.',
      cloudRefusalInvalidRadius: 'Polmer mora biti med 50 in 5000 metri.',
      cloudRefusalInvalidArea: 'Preverite ime in položaj območja.',
      cloudRefusalGeneric: 'Oblak je spremembo zavrnil.',
    },

    // Rooms view
    rooms: {
      pageTitle: 'Prostori',
      searchPlaceholder: 'Iščite po prostoru ali območju...',
      loading: 'Nalaganje...',
      emptyTitle: 'Ni prostorov',
      emptyDescription: 'Za začetek ustvarite nov prostor.',
      noResultsTitle: 'Ni najdenih prostorov',
      noResultsDescription: 'Poskusite z drugim iskalnim izrazom.',
      unassignedRoomsSectionTitle: 'Nedodeljeni prostori',
      loadError: 'Nalaganje podatkov ni uspelo',
    },

    // Skeniranje prostorov (kartica `t_90febbcf`, A2): vstopna točka in plošča
    // (`components/scan/RoomScanEntry.vue` + `RoomScanPanel.vue`). Skenira sam
    // vgrajeni vtičnik `RoomScan` (iOS, LiDAR); `unsupported*` so pošteni odgovori
    // naprave brez LiDAR-a (načrt §7).
    // 3D skeni (kartica `t_8ae1d20a`, E2): nastavitvena stran, ki našteje
    // skeniranja, shranjena na TEM vozlišču (`views/Settings/SettingsModel.vue`),
    // z nalaganjem, zamenjavo, prenosom in brisanjem, ter gumb za skeniranje.
    model: {
      title: '3D model',
      subtitle: 'Edini 3D model tega vozlišča in skeni, iz katerih lahko nastane.',
      homeTitle: 'Domači 3D model',
      homeIntro: 'Vse strani, ki prikazujejo hišo, upodobijo te bajte — model je eden na vozlišče.',
      upload: 'Naloži model …',
      replace: 'Zamenjaj …',
      download: 'Prenesi',
      delete: 'Izbriši',
      active: 'Aktivni',
      updated: 'Posodobljeno',
      loading: 'Berem model …',
      loadFailed: 'Modela vozlišča ni bilo mogoče prebrati',
      empty: 'Na tem vozlišču še ni 3D modela — naložite datoteko IFC, GLB ali glTF ali uporabite 3D sken spodaj.',
      uploading: 'Nalaganje modela …',
      uploadDone: 'Model je naložen.',
      uploadFailed: 'Modela ni bilo mogoče naložiti',
      badFormat: 'Izberite datoteko IFC (.ifc), GLB (.glb) ali glTF (.gltf).',
      tooLarge: 'Datoteka modela mora biti manjša od 200 MB.',
      downloading: 'Prenašam model …',
      downloadDone: 'Model je shranjen kot »{name}«.',
      downloadFailed: 'Modela ni bilo mogoče prenesti',
      deleting: 'Odstranjujem model …',
      deleteTitle: 'Odstrani 3D model',
      deleteMessage:
        'Odstranim 3D model vozlišča »{name}«? Izgubijo ga vse strani, ki prikazujejo hišo, 3D pogled pa ostane prazen, dokler ne naložite drugega modela.',
      deleteDone: '»{name}« je odstranjen.',
      deleteFailed: 'Modela ni bilo mogoče izbrisati',
      scanIsModel: '»{name}« je zdaj 3D model vozlišča.',
    },
    scans: {
      title: '3D skeni',
      subtitle: 'Skeniranja prostorov, shranjena na tem vozlišču. Skenirajte prostor s kamero ali naložite paket posnetka s telefona.',
      scanRoom: 'Skeniraj prostor',
      scanRoomHint: 'Končano skeniranje se samodejno naloži na to vozlišče.',
      uploadPackage: 'Naloži paket',
      refresh: 'Osveži',
      hubTitle: 'Na vozlišču',
      deviceTitle: 'Posnetki na tej napravi',
      deviceEmpty: 'Na tej napravi še ni posnetkov.',
      deviceOnHub: 'Na vozlišču',
      deviceUpload: 'Naloži',
      loading: 'Nalaganje skeniranj …',
      loadFailed: 'Skeniranj s tega vozlišča ni bilo mogoče naložiti',
      emptyTitle: 'Ni še nobenega skeniranja — skenirajte prvi prostor',
      emptyHint:
        'Paket skeniranja je mapa, ki jo zapiše posnetek (scan.json, model.usdz, tloris …). Naložite jo tukaj ali skenirajte z aplikacijo.',
      modeRoom: 'Ena soba',
      modeStructure: 'Nadstropje',
      rooms: '{count} prostor | {count} prostora | {count} prostori | {count} prostorov',
      files: '{count} datoteka | {count} datoteki | {count} datoteke | {count} datotek',
      capturedAt: 'Posneto',
      updatedAt: 'Posodobljeno',
      download: 'Prenesi',
      replace: 'Zamenjaj',
      delete: 'Izbriši',
      close: 'Zapri',
      retry: 'Poskusi znova',
      working: 'Delam …',
      reading: 'Berem posnetek s te naprave …',
      uploading: 'Nalaganje na vozlišče …',
      replacing: 'Zamenjava na vozlišču …',
      downloading: 'Prenos z vozlišča …',
      progress: '{percent} % naloženega',
      progressUnknown: 'Vozlišče prejema paket …',
      uploadDone: '»{name}« je na vozlišču.',
      replaceDone: '»{name}« je zamenjan.',
      deleteDone: '»{name}« je izbrisan z vozlišča.',
      downloadDone: '»{name}« shranjen — {count} datoteka | »{name}« shranjen — {count} datoteki | »{name}« shranjen — {count} datoteke | »{name}« shranjen — {count} datotek',
      deleteTitle: 'Izbrišem to skeniranje?',
      deleteMessage: 'Izbrišem »{name}« z vozlišča? Njegove datoteke se izbrišejo z njim in tega ni mogoče razveljaviti.',
      validationTitle: 'Ta paket ni bil poslan',
      replaceTitle: 'Zamenjam »{name}«',
      replaceHint: 'Novi paket prevzame mesto skeniranja — datoteke, ki jih ima zdaj, se izbrišejo.',
      replaceChooseCapture: 'Posnetek na tej napravi',
      replaceChooseFiles: 'Izberi datoteke s te naprave …',
      replaceNoCaptures: 'Na tej napravi ni posnetkov.',
      replaceUseCapture: 'Uporabi ta posnetek',
      invalid: {
        empty: 'Najprej izberite datoteke paketa posnetka.',
        tooManyFiles: 'Paket ima lahko največ {max} datotek.',
        fileTooLarge: '»{name}« je večja od {max} MB.',
        packageTooLarge: 'Paket je večji od {max} MB.',
        badFileName: '»{name}« ni mogoče shraniti — ime v paketu nima poti, ne začne se s piko in se ne konča s piko ali presledkom.',
        duplicateName: '»{name}« je v paketu dvakrat.',
        missingUsdz: 'Paket potrebuje geometrijo prostora — datoteko .usdz.',
        badScanDoc: 'scan.json ni dokument torik.scan/v0.',
        generic: 'Paketa ni mogoče poslati takega, kot je.',
      },
      warnings: {
        missingScanDoc: 'V paketu ni scan.json — vozlišče ga shrani kot posnetek na ravni prostora.',
      },
      errors: {
        noHub: 'Tega vozlišča zdaj ni mogoče doseči.',
        auth: 'Vozlišče je zavrnilo to sejo — prijavite se znova.',
        validation: 'Vozlišče je paket zavrnilo.',
        readFailed: 'Posnetka s te naprave ni bilo mogoče prebrati.',
        uploadFailed: 'Nalaganje se ni končalo.',
        downloadFailed: 'Prenos se ni končal.',
        saveFailed: 'Datoteke ni bilo mogoče shraniti na to napravo.',
        unknown: 'Prenos se ni končal.',
      },
      model: {
        title: 'Skeniraj 3D',
        intro: 'Skeniraj prostor s kamero — končan posnetek se sam naloži na ta hub, vsak sken pa lahko postane 3D model hiše na tem hubu.',
        scan3d: 'Skeniraj 3D',
        empty: 'Na tem hubu še ni skenov — začni s “Skeniraj 3D”.',
        useScan: 'Uporabi kot model',
        selected: 'Izbrano kot model',
        noModel: 'V paketu ni datoteke modela',
        loadingFile: 'Branje skena s huba …',
        attaching: 'Sken se pripenja kot 3D model huba …',
        fetchFailed: 'Skena s huba ni bilo mogoče prebrati',
        attachFailed: 'Sken ni mogel postati 3D model huba',
      },
    },

    roomScan: {
      entryTitle: 'Skenirajte prostore s kamero',
      entry: 'Skeniraj',
      title: 'Skeniranje prostorov',
      checking: 'Preverjam, ali lahko ta naprava skenira …',
      unsupportedTitle: 'Ta naprava ne more skenirati prostorov',
      unsupportedLidar: 'RoomPlan potrebuje iPhone Pro ali iPad Pro — prostor meri LiDAR.',
      unsupportedPlatform: 'Skeniranje prostorov deluje v aplikaciji Torik na iPhonu Pro ali iPadu Pro (LiDAR).',
      errorTitle: 'Skeniranje se ni zaključilo',
      nameLabel: 'Ime tega skeniranja (neobvezno)',
      namePlaceholder: 'npr. Dnevna soba',
      startRoom: 'Skeniraj sobo',
      startStructure: 'Skeniraj celotno nadstropje',
      startHint: 'Pogled kamere vas vodi skozi postopek — premikajte se počasi in poskrbite za svetlobo.',
      capturingRoom: 'Skeniranje sobe poteka …',
      capturingRoomFloor: 'Skeniranje te sobe v nadstropju poteka …',
      capturingHint: 'Prehodite sobo in nato v pogledu kamere pritisnite Končano.',
      structureRooms: 'Posnetih prostorov: {count}',
      structureHint: 'Vsak Končano shrani eno sobo; Dokončaj jih združi v en model.',
      scanAnother: 'Skeniraj še eno sobo',
      finish: 'Dokončaj',
      saved:
        'Shranjeno: {label} · {count} prostor | Shranjeno: {label} · {count} prostora | Shranjeno: {label} · {count} prostori | Shranjeno: {label} · {count} prostorov',
      scanFile: 'Podatki modela',
      capturesTitle: 'Na tej napravi',
      capturesEmpty: 'Na tej napravi še ni skeniranj.',
      modeRoom: 'Ena soba',
      modeStructure: 'Nadstropje',
      rooms: '{count} prostor | {count} prostora | {count} prostori | {count} prostorov',
      deleteConfirm: 'Izbrišem skeniranje »{label}«? Dokler pošiljanje v oblak ni na voljo, obstaja le na tej napravi.',
    },

    // Devices view
    devices: {
      pageTitle: 'Naprave',
      searchPlaceholder: 'Iščite naprave...',
      groupByRooms: 'Prostori',
      groupByTypes: 'Tipi',
      loading: 'Nalaganje naprav...',
      noResultsTitle: 'Ni najdenih naprav',
      noResultsDescription: 'Poskusite z drugim iskalnim izrazom.',
      emptyTitle: 'Ni naprav',
      emptyDescription: 'Za začetek dodajte novo napravo.',
      noRoomLabel: 'Brez prostora',
      noRoomsWithDevicesTitle: 'Ni prostorov z napravami',
      noRoomsWithDevicesDescription: 'Dodajte naprave in jih dodelite prostorom, da jih vidite organizirane tukaj.',
      unknownType: 'Neznan tip',
      emptyTypeViewDescription: 'Dodajte naprave, da jih vidite organizirane po tipu.',
      deleteConfirmTitle: 'Izbriši napravo',
      deleteConfirmMessage: 'Ali ste prepričani, da želite izbrisati {deviceName}?',
      cancelButton: 'Prekliči',
      deleteButton: 'Izbriši',
      deletingButton: 'Brisanje...',
      loadError: 'Nalaganje podatkov ni uspelo',
    },

    // Scenes view
    scenes: {
      pageTitle: 'Scene',
      searchPlaceholder: 'Iščite scene...',
      addSceneButton: 'Dodaj sceno',
      reorderButton: 'Preuredi',
      doneButton: 'Končano',
      cancelButton: 'Prekliči',
      deleteButton: 'Izbriši',
      loading: 'Nalaganje',
      emptyTitle: 'Še ni scen',
      emptyDescription: 'Ustvarite sceno za začetek.',
      noResultsTitle: 'Ni ujemajočih se scen',
      deleteConfirmTitle: 'Izbriši sceno',
      deleteConfirmMessage: 'Ali ste prepričani, da želite izbrisati',
      loadError: 'Nalaganje scen ni uspelo',
      executionSuccess: 'Scena uspešno izvedena',
      executionError: 'Izvedba končana z napakami',
    },

    // Routines view
    routines: {
      pageTitle: 'Rutine',
      loading: 'Nalaganje rutin...',
      createButton: 'Ustvari rutino',
      editButton: 'Uredi',
      runNowButton: 'Zaženi zdaj',
      emptyTitle: 'Še ni rutin',
      emptyDescription: 'Ustvarite svojo prvo rutino za avtomatizacijo vašega pametnega doma',
      triggerCount: 'prožilec | prožilci',
      conditionCount: 'pogoj | pogoji',
      actionCount: 'dejanje | dejanja',
      deleteConfirmMessage: 'Ali ste prepričani, da želite izbrisati to rutino?',
      loadError: 'Nalaganje rutin ni uspelo',
      deleteError: 'Brisanje rutine ni uspelo',
      enabledMessage: 'Rutina omogočena',
      disabledMessage: 'Rutina onemogočena',
      deletedMessage: 'Rutina izbrisana',
      executionStartedMessage: 'Izvajanje rutine se je začelo',
      executionError: 'Izvajanje rutine ni uspelo',
      // The row a dead device-value reference paints (Routine*Editor): a stored
      // routine action/condition/trigger whose valueId is no longer on the hub.
      missingDeviceValueTitle: 'Ta vrednost naprave ne obstaja več',
      missingDeviceValueHint:
        'Znova izberite napravo in lastnost - rutina se ne bo izvajala, dokler tega ne popravite.',
      storedValue: 'Shranjena vrednost',
      storedValueOn: 'Vklop',
      storedValueOff: 'Izklop',
      readOnly: 'samo za branje',
      // What a *run* of the routine did (card t_5db7015a): the last-run line on
      // the card and the Runs tab of the editor read the hub's own execution
      // history, which nothing in the app read before.
      lastRunLabel: 'Zadnja izvedba',
      runNever: 'Se ni izvedla',
      runStatusCompleted: 'Zaključeno',
      runStatusFailed: 'Neuspešno',
      runStatusSkipped: 'Izpuščeno',
      runStatusRunning: 'V teku',
      runCompletedMessage: 'Rutina se je izvedla',
      runSkippedMessage: 'Rutina se je izvedla, a pogoji niso bili izpolnjeni',
      runFailedMessage: 'Izvedba ni uspela: {reason}',
      runFailedNoReason: 'Izvedba ni uspela',
      triggerManual: 'Ročno',
      historyEmpty: 'Ta rutina se še ni izvedla.',
      historyEmptyHint: 'Zažene se ob sprožitvi sprožilca ali ob pritisku na Zaženi zdaj.',
      historyLoadError: 'Zgodovine izvedb ni bilo mogoče naložiti.',
      historyTruncated: 'Prikazanih je le zadnjih 50 izvedb.',
      // Sporočila, ki jih piše hub sam (RoutineService.ts); vse drugo se izpiše
      // tako, kot ga je vrnil hub (utils/routineRuns.ts).
      errorNoValueReference: 'Rutina kaže na vrednost naprave, ki je hub nima več.',
      errorMissingValueId: 'Dejanju manjka vrednost naprave.',
      errorMissingSceneId: 'Dejanju manjka scena.',
      errorSceneNotFound: 'Scena, ki jo dejanje zažene, ne obstaja več.',
      errorMissingUrl: 'Dejanju webhooka manjka naslov URL.',
      errorMissingNotificationText: 'Dejanju obvestila manjka naslov ali sporočilo.',
      errorRoutineNotFound: 'Rutina ne obstaja več na hubu.',
    },

    // Media view
    media: {
      audioZonesTitle: 'Avdio cone',
      newZoneButton: 'Nova cona',
      createZoneTitle: 'Ustvari cono',
      noAudioZonesTitle: 'Še ni avdio con',
      noAudioZonesDescription: 'Ustvarite cono in ji dodajte plošče ali aplikacije.',
      pausedLabel: 'Premor',
      noMediaPlayersTitle: 'Ni medijskih predvajalnikov',
      noMediaPlayersDescription: 'Dodajte medijsko integracijo za odkrivanje predvajalnikov.',
      goToIntegrations: 'Pojdi na integracije',
      noLocalMediaMessage: 'V knjižnici še ni medijev.',
    },

    // Cameras view
    cameras: {
      pageTitle: 'Kamere',
      liveTab: 'V živo',
      playbackTab: 'Predvajanje',
      onlineLabel: 'na spletu',
      intercomLabel: 'domofon',
      unlockSecretCamerasTitle: 'Vnesite PIN za ogled skrivnih kamer',
      secretButton: 'Skrivnost',
      editButton: 'Uredi',
      doneButton: 'Končano',
      secretCameraTitle: 'Skrivna kamera - skrijem pred gosti',
      loading: 'Nalaganje kamer...',
      noCamerasFoundMessage: 'Ni najdenih kamer. Dodajte kamere v nastavitvah integracij.',
      refreshSnapshotTitle: 'Osveži posnetek',
      privacyBlurTitle: 'Zameglitev zasebnosti',
      privacyBlurMenuTitle: 'Trajanje zamegljitve',
      blur5Min: '5 minut',
      blur15Min: '15 minut',
      blur30Min: '30 minut',
      blur1Hour: '1 ura',
      blur2Hours: '2 uri',
      removeBlurButton: 'Odstrani zameglitev',
      muteMotionNotificationsTitle: 'Utišaj obvestila o gibanju',
      muteMotionNotificationsMenuTitle: 'Utišaj obvestila o gibanju za',
      unmuteMotionNotificationsButton: 'Vklopi obvestila o gibanju',
      intercomBadge: 'Domofon',
      callDoorphoneTitle: 'Pokliči vhodni telefon',
      editModeInstructions: 'Uporabite puščice za preurejanje · Kliknite ključavnico za označevanje kot skrivnost',
      cancelButton: 'Prekliči',
      savingButton: 'Shranjevanje...',
      saveOrderButton: 'Shrani vrstni red',
      selectCamerasMessage: 'Izberite kamere zgoraj za začetek predvajanja',
      // Kamera v živo, katere ICE se nikoli ne zaključi: ponudba WHEP je bila
      // sprejeta, medijska pot pa ni stekla. `services/mediaPath.ts` omeji čakanje
      // in poimenuje stanje; predvajalnika izpišeta ta stavek (kartica t_20b35b28).
      mediaPathFailed:
        'Medijske poti do te kamere ni bilo mogoče vzpostaviti — kamera je zahtevo sprejela, a video ali avdio povezava ni stekla. Poskusite znova, odprite kamerino lastno aplikacijo ali preverite dnevnik go2rtc na vozlišču.',
      // Zakaj se je poskus končal, izpisano pod stavkom (kartica t_4d5b3263):
      // trije vzroki zahtevajo različne naslednje korake in na zaslonu se izpiše
      // samo vzrok — popis zbranih kandidatov in časi ostanejo v konzoli in v
      // opozorilih `services/mediaPath.ts`, nikoli na zaslonu.
      mediaPathReasonBudget:
        'Omrežna pot do kamere se ni vzpostavila pravočasno — vzrok je običajno omrežje vozlišča, ne kamera.',
      mediaPathReasonFailed: 'Omrežna pot do kamere je odpovedala — pred ponovnim poskusom preverite omrežje vozlišča.',
      mediaPathReasonNoCandidates: 'Ta naprava ni mogla pripraviti povezave s kamero.',
    },

    // Account view
    account: {
      profileInformationTitle: 'Podatki profila',
      profilePictureLabel: 'Profilna slika',
      changePictureButton: 'Spremeni sliko',
      pictureFormatHint: 'PNG ali JPG (največ 2MB)',
      fullNameLabel: 'Polno ime',
      fullNamePlaceholder: 'Vnesite svoje polno ime',
      emailLabel: 'E-poštni naslov',
      emailPlaceholder: "uporabnik{'@'}primer.si",
      phoneLabel: 'Telefonska številka',
      phonePlaceholder: '+386 (41) 123-456',
      bioLabel: 'Bio',
      bioPlaceholder: 'Povejte nam kaj o sebi',
      saveProfileButton: 'Shrani profil',
      savingButton: 'Shranjevanje...',
      securitySettingsTitle: 'Varnostne nastavitve',
      // Vozliščevo lastno lokalno geslo (odločitev D1): za vsakega uporabnika,
      // neobvezno, preveri ga to vozlišče brez obiska oblaka — vrata, ki jih ima
      // oseba ob krmilniku tudi takrat, ko v hiši ni interneta.
      localPasswordTitle: 'Lokalno geslo',
      localPasswordSetHint: 'S tem geslom se prijavite, ko ni interneta. Preveri ga to vozlišče samo.',
      localPasswordUnsetHint:
        'Nastavite geslo za neposredno prijavo v to vozlišče, ko ni interneta. Ni obvezno — brez njega se naprava poveže v to vozlišče kot običajno.',
      localPasswordCurrent: 'Trenutno geslo',
      localPasswordNew: 'Novo geslo (najmanj 8 znakov)',
      localPasswordConfirm: 'Ponovite novo geslo',
      localPasswordMismatch: 'Gesli se ne ujemata.',
      localPasswordNoRecovery: 'Tega gesla ne more povrniti nič brez vašega računa Torik.',
      localPasswordSet: 'Nastavi geslo',
      localPasswordChange: 'Spremeni geslo',
      localPasswordSaving: 'Shranjevanje …',
      localPasswordSaved: 'Lokalno geslo je shranjeno.',
      localPasswordRemove: 'Odstrani lokalno geslo',
      localPasswordRemoveConfirm:
        'Odstranim lokalno geslo? Prijava v to vozlišče brez interneta ne bo delovala, dokler ni nastavljeno novo.',
      localPasswordRemoving: 'Odstranjujem …',
      localPasswordRemoved: 'Lokalno geslo je odstranjeno.',
      preferencesTitle: 'Nastavitve',
      themeLabel: 'Tema',
      languageLabel: 'Jezik',
      notificationsTitle: 'Obvestila',
      savePreferencesButton: 'Shrani nastavitve',
      memberSinceLabel: 'Član od',
      lastLoginLabel: 'Zadnja prijava',
      sessionTitle: 'Seja',
      logoutDescription: 'Odjavite se iz trenutne seje.',
      profileTabLabel: 'Profil',
      securityTabLabel: 'Varnost',
      preferencesTabLabel: 'Nastavitve',
      infoTabLabel: 'Info',
      themeSystemDefault: 'Privzeto sistema',
      themeLightOption: 'Svetlo',
      themeDarkOption: 'Temno',
      languageEnglish: 'English',
      languageSpanish: 'Español',
      languageFrench: 'Français',
      languageGerman: 'Deutsch',
      languageItalian: 'Italiano',
      languageSlovenian: 'Slovenščina',
      temperatureUnitsLabel: 'Temperature enote',
      celsiusOption: 'Celsius (°C)',
      fahrenheitOption: 'Fahrenheit (°F)',
      notificationGroupAlerts: 'Opozorila',
      notificationGroupAlertsDetail: 'Opozorila naprav in težave vozlišča',
      notificationGroupAutomation: 'Avtomatizacija in obvestila',
      notificationGroupAutomationDetail: 'Avtomatizacije, rutine, časomerilci in opomniki',
      notificationGroupMessages: 'Klici in sporočila',
      notificationGroupMessagesDetail: 'Klici in klepetalna sporočila',
      notificationGroupPartly: 'Delno vklopljeno',
      notificationGroupsUnavailable: 'Vaših nastavitev obvestil ni bilo mogoče naložiti.',
      userNotifications: {
        typeDeviceAlert: 'Opozorila naprav',
        typeSystem: 'Težave vozlišča',
        typeAutomation: 'Avtomatizacije',
        typeRoutine: 'Rutine',
        typeInfo: 'Obvestila',
        typeCall: 'Klici',
        typeChat: 'Klepetalna sporočila',
        channelPush: 'Potisna',
        channelInApp: 'V aplikaciji',
        unavailable: 'Teh nastavitev obvestil ni bilo mogoče naložiti.',
      },
      accountInformationTitle: 'Podatki o računu',
      logOutButton: 'Odjava',
      loggingOutButton: 'Odjavljanje...',
      notSetLabel: 'Ni nastavljeno',
      roleLabel: 'Vloga',
      userRoleDefault: 'Uporabnik',
    },

    // Notifications view
    notifications: {
      title: 'Obvestila',
      markAllAsRead: 'Označi vse kot prebrano',
      clearAll: 'Počisti vse',
      tabAll: 'Vsa obvestila',
      tabUnread: 'Neprebrano',
      tabByType: 'Po tipu',
      loading: 'Nalaganje obvestil...',
      emptyState: 'Še ni obvestil',
      emptyUnread: 'Vse prebrano! Ni neprebranih obvestil',
      noNotificationsOfType: 'Ni obvestil te vrste',
      markAsUnread: 'Označi kot neprebrano',
      markAsRead: 'Označi kot prebrano',
      deleteButton: 'Izbriši',
      deleteAllConfirm: 'Izbrisati vsa obvestila?',
      timeJustNow: 'Pravkar',
      timeMinutesAgo: 'min',
      timeHoursAgo: 'ur',
      timeDaysAgo: 'dni',
    },

    // Alarms view
    alarms: {
      title: 'Alarmi',
      newAlarm: 'Nov alarm',
      emptyState: 'Še ni alarmov. Dotaknite se Nov alarm za začetek.',
      editAlarmTitle: 'Uredi alarm',
      labelField: 'Oznaka',
      labelPlaceholder: 'Prebujanje',
      timeField: 'Čas',
      repeatField: 'Ponavljanje',
      noDaysHelp: 'Noben dan ni izbran = enkratni alarm',
      snoozeField: 'Trajanje dremeža (minute)',
      soundField: 'Zvok',
      cancel: 'Prekliči',
      saveAlarm: 'Shrani alarm',
      saving: 'Shranjevanje...',
      confirmDelete: 'Izbrišem ta alarm?',
      daysSu: 'Ne',
      daysMo: 'Po',
      daysTu: 'To',
      daysWe: 'Sr',
      daysTh: 'Če',
      daysFr: 'Pe',
      daysSa: 'So',
    },

    // People view
    people: {
      title: 'Osebe',
      searchPlaceholder: 'Iščite pogovore...',
      loading: 'Nalaganje...',
      emptyPeople: 'Ni najdenih oseb',
      selfDMDescription: 'Shranjevanje sporočil, datotek in povezav',
      selfBadge: 'Jaz',
      selfConversationHint: 'To lahko vidite samo vi',
      participantsLabel: 'udeleženci',
      audioCallTitle: 'Avdio klic',
      videoCallTitle: 'Video klic',
      moreOptionsTitle: 'Več možnosti',
      deleteAllMessages: 'Izbriši vsa sporočila',
      captionPlaceholder: 'Dodajte napis (izbirno)...',
      messagePlaceholder: 'Vnesite sporočilo...',
      someoneTyping: 'Nekdo tipka...',
    },

    // Areas view

    // Integrations view
    integrations: {
      title: 'Integracije',
      addIntegration: 'Dodaj integracijo',
      loading: 'Nalaganje integracij...',
      emptyTitle: 'Ni integracij',
      emptyMessage: 'Za začetek dodajte novo integracijo.',
      delete: 'Izbriši',
      deleteTitle: 'Izbriši integracijo',
      confirmDeletePrefix: 'Ali ste prepričani, da želite izbrisati',
      confirmDeleteSuffix: ' ? To bo odstranilo tudi vse povezane naprave.',
      cancel: 'Prekliči',
      deleting: 'Brisanje...',
      statusDisabled: 'Onemogočeno',
      statusConnected: 'Povezano',
      statusDisconnected: 'Prekinjeno',
      statusNotConfigured: 'Ni konfigurirano',
      statusDemo: 'Demo',
      demoMode: 'Demo način',
      demoModeOn: 'Demo vklopljen',
      demoModeSaving: 'Shranjujem …',
      demoModeTooltip:
        'Demo način: integracija je odklopljena od prave naprave in prikazuje simulirane vrednosti. Izklopite za pravo povezavo.',
      demoModeHint: 'Simuliraj to integracijo — brez prometa do prave naprave ali vodila.',
      demoModeActiveHint: 'Delovanje na simuliranih vrednostih (demo gonilnik). Strojna oprema ni v uporabi.',
    },

    // Agent view
    agent: {
      title: `${brand.agentName}`,
      subtitle: 'Glasovni in besedilni asistent',
      reset: 'Ponastavi',
      resetTitle: 'Ponastavi, če je agent obtičal',
      clearButton: 'Počisti',
      history: 'Zgodovina',
      emptyTitle: 'Kako vam lahko pomagam?',
      emptyMessage: 'Poskusite me prositi, da upravljam naprave, preverim stanje ali upravljam vaš dom',
      thinking: 'Razmišljanje...',
      stop: 'Ustavi',
      listeningIndicator: '🎤 Poslušam... Govorite zdaj',
      placeholder: 'Vnesite sporočilo ali uporabite glas...',
      noHistory: 'Še ni zgodovine pogovorov',
      suggestionLights: 'Vklopi luči v dnevni sobi',
      suggestionTemperature: 'Kakšna je temperatura?',
      suggestionCameras: 'Pokaži mi kamere',
      suggestionScene: 'Zaženi sceno lahko noč',
    },

    // Room view
    room: {
      floorLabel: 'Nadstropje',
      addDevice: 'Dodaj napravo',
      editRoom: 'Uredi prostor',
      moreActions: 'Več dejanj',
      emptyTitle: 'V tem prostoru ni naprav',
      emptyMessage: 'Kliknite "Dodaj napravo", da dodate eno v ta prostor.',
      scenesSection: 'Scene',
      addScene: 'Dodaj sceno',
      reorderScenes: 'Preuredi scene',
      reorder: 'Preuredi',
      dragScenesToReorder: 'Povleci scene za preurejanje',
      chartsSection: 'Grafi',
      deleteTitle: 'Izbriši napravo',
      confirmDeletePrefix: 'Ali ste prepričani, da želite izbrisati',
      confirmDeleteSuffix: ' ?',
      cancel: 'Prekliči',
      deleting: 'Brisanje...',
      devicesSection: 'Naprave',
      editLayout: 'Uredi postavitev',
      done: 'Končano',
      editHint: 'Povlecite naprave za preurejanje. Z orodno vrstico vsake naprave izberite, kako naj se prikaže.',
      dragToReorder: 'Povleci za preurejanje',
      deviceSettings: 'Nastavitve naprave',
      displayAuto: 'Samodejno',
      displayButton: 'Gumb',
      displayFull: 'Polna širina',
      displayIcon: 'Ikona',
      layout: 'Postavitev',
      layoutImageAlt: '{room} — postavitev',
      dragHandle: 'povleci',
      otherType: 'Drugo',
    },

    dashboardNew: {
      actionsMenuTitle: 'Dejanja nadzorne plošče',
      addDashboardAction: 'Dodaj nadzorno ploščo',
      addWidgetAction: 'Dodaj gradnik',
      editDashboardAction: 'Uredi nadzorno ploščo',
      toggleEditModeAction: 'Preklopi način urejanja',
      gridSettingsAction: 'Nastavitve mreže',
      loadingMessage: 'Nalaganje nadzorne plošče...',
      retryButton: 'Poskusi znova',
      defaultDashboardName: 'Nadzorna plošča',
      loadFailed: 'Nalaganje nadzorne plošče ni uspelo',
      createFailed: 'Ustvarjanje nadzorne plošče ni uspelo',
      createFromTemplateFailed: 'Ustvarjanje nadzorne plošče iz predloge ni uspelo',
      welcomeHeading: `Dobrodošli v ${brand.platformCompact}`,
      welcomeDescription: 'Začnite z ustvarjanjem prve nadzorne plošče iz predloge ali iz nič.',
      createDashboardButton: 'Ustvari nadzorno ploščo',
    },

    // Settings views
    settingsSystem: {
      title: 'Sistemske nastavitve',
      systemName: 'Ime sistema',
      systemNamePlaceholder: `${brand.platformCompact}`,
      systemImage: 'Slika sistema',
      changeImage: 'Spremeni sliko',
      uploadImage: 'Naloži sliko',
      removeImage: 'Odstrani',
      imageSizeLimit: 'PNG, JPG ali WebP (največ 5MB)',
      imageTooLarge: 'Slika je prevelika (največ 10MB)',
      imageUploaded: 'Slika uspešno naložena',
      imageRemoved: 'Slika uspešno odstranjena',
      saveSystemSettings: 'Shrani sistemske nastavitve',
      savingSystem: 'Shranjevanje...',
      cloudServices: 'Storitve v oblaku',
      connected: 'Povezan',
      disconnected: 'Nepovezan',
      connecting: 'Povezovanje...',
      connectionError: 'Napaka pri povezovanju',
      notRegistered: 'Ni registrirano',
      registerCloudDescription:
        'Registrirajte svoje vozlišče v storitve v oblaku, da omogočite oddaljeni dostop in skupno rabo.',
      cloudAccount: 'Račun v oblaku',
      cloudAccountEmail: 'E-pošta računa v oblaku',
      emailPlaceholder: "email{'@'}example.com",
      cloudUrl: 'URL oblaka',
      registerWithCloud: 'Registriraj v oblaku',
      registering: 'Registriranje...',
      reconnect: 'Ponovno poveži',
      reconnecting: 'Ponovno povezovanje...',
      unregister: 'Odregistriraj',
      unregistering: 'Odregistriranje...',
      sharedWith: 'V skupni rabi z',
      hubNotShared: 'To vozlišče ni v skupni rabi z nikomer drugim.',
      removeAccess: 'Odstrani',
      viewOnly: 'Samo ogled',
      control: 'Nadzor',
      admin: 'Admin',
      emailToSharePlaceholder: "uporabnik{'@'}example.com",
      add: 'Dodaj',
      adding: 'Dodajanje...',
      loading: 'Nalaganje...',
      saving: 'Shranjevanje...',
      settingsSaved: 'Nastavitve uspešno shranjene',
      hubLocation: 'Lokacija vozlišča',
      locationDescription: 'Lokacija vozlišča se uporablja za napovedi vremena in izračune sončnega vzhoda/zahoda.',
      automaticLocation: 'Samodejno',
      manual: 'Ročno',
      pickLocation: 'Izberi lokacijo na karti',
      latitude: 'Geografska širina',
      latitudePlaceholder: 'npr. 46.1199',
      longitude: 'Geografska dolžina',
      longitudePlaceholder: 'npr. 14.4992',
      elevation: 'Nadmorska višina (metri)',
      elevationPlaceholder: 'npr. 500',
      location: 'Lokacija',
      saveHubLocation: 'Shrani lokacijo vozlišča',
      weather: 'Vreme',
      weatherLocation: 'Lokacija vremenske postaje',
      searchCityPlaceholder: 'Vnesite ime mesta',
      units: 'Enote',
      metric: 'Metrično (°C, m/s)',
      imperial: 'Anglosaško (°F, mph)',
      saveWeatherSettings: 'Shrani nastavitve vremenske postaje',
      cityRequired: 'Mesto je obvezno',
      weatherSettingsSaved: 'Vremenske nastavitve so shranjene',
      citySearchFailed: 'Iskanje mest ni uspelo',
      searchCity: 'Iskanje mesta',
      enterCityName: 'Vnesite ime mesta',
      searching: 'Iskanje v teku...',
      search: 'Iskalnik',
      noCitiesFound: 'Nobeno mesto ni najdeno',
      enterCitySearch: 'Vnesite najmanj 2 znaka za iskanje',
      close: 'Zapri',
      checkForUpdates: 'Preveri posodobitve',
      checking: 'Preverjanje...',
      confirmInstall: 'Namestiti posodobitev? Sistem se bo znova zagnal.',
      confirmRollback: 'Povrniti prejšnjo različico? Sistem se bo znova zagnal.',
      installUpdate: 'Namesti posodobitev',
      installing: 'Nameščanje...',
      systemUpdates: 'Sistemske posodobitve',
      securityUpdateTooltip: 'Varnostna posodobitev',
      currentVersionLabel: 'Trenutna različica',
      channelLabel: 'Kanal',
      lastCheckedLabel: 'Nazadnje preverjeno',
      updateAvailableLabel: 'Na voljo je posodobitev',
      lastUpdatedLabel: 'Nazadnje posodobljeno',
      kernelLabel: 'jedro',
      checkingForUpdates: 'Preverjanje posodobitev...',
      applianceUpdateHint: 'Kliknite Preveri posodobitve, da preverite nove izdaje naprave.',
      platformdUpToDate: 'Demon platforme je posodobljen.',
      platformdNoUpdate: 'Za demon platforme ni na voljo posodobitve.',
      platformdUpdateHint: 'Kliknite Preveri posodobitve, da preverite izdaje demona platforme.',
      systemUpdatesDisabled: 'Sistemske posodobitve na tej napravi niso omogočene.',
      updateCheckFailed: 'Preverjanje posodobitev naprave ni uspelo.',
      updateStatusInProgress: 'Posodobitev je trenutno v teku.',
      updateInstalling: 'Posodobitev se namešča — vozlišče se bo ob koncu znova zagnalo.',
      updateStatusInstalling: 'Posodobitev se namešča — vozlišče se bo ob koncu znova zagnalo.',
      updateStatusNotRegistered: 'Preden lahko vozlišče preveri izdaje naprave, je potrebna registracija v oblaku.',
      updateStatusBlocked: 'To vozlišče potrebuje vmesno nadgradnjo, preden lahko namesti najnovejšo izdajo naprave.',
      updateStatusNoRelease: 'Za ta kanal trenutno ni na voljo nobene objavljene izdaje naprave.',
      updateStatusUpToDate: 'To vozlišče že uporablja najnovejšo objavljeno izdajo naprave.',
      updateStatusUnreachable: 'Storitve za posodobitve ni bilo mogoče doseči.',
      updateStatusNoUpdate: 'Posodobitev naprave trenutno ni na voljo.',
      updateStarted: 'Posodobitev se je začela. Vozlišče se bo znova zagnalo, če bo nameščena nova izdaja naprave.',
      updateStartFailed: 'Posodobitve naprave ni bilo mogoče začeti.',
      rollbackInitiated:
        'Povrnitev na prejšnjo različico se je začela. Vozlišče se bo znova zagnalo, če je na voljo slika za povrnitev.',
      rollbackStartFailed: 'Povrnitve na prejšnjo različico ni bilo mogoče začeti.',
      systemUpdateCheckFailed: 'Preverjanje sistemskih posodobitev ni uspelo',
      systemInstallFailed: 'Namestitev ni uspela',
      platformdUpdate: 'Demon platforme',
      platformdUpdateDescription: 'Sistemska storitev, ki upravlja omrežje, strojno opremo in posodobitve naprave',
      installPlatformd: 'Posodobi demon platforme',
      confirmInstallPlatformd: 'Posodobiti demon platforme? Storitev se bo na kratko znova zagnala.',
      platformdUpdateInProgress: 'Posodobitev demona platforme je v teku — storitev se bo ob koncu znova zagnala.',
      licence: 'Licenca',
      manageLicence: 'Upravljaj licenco',
      noPlan: 'Brez paketa',
      unlimitedSeats: 'Neomejeno sedežev',
      oneSeat: '1 sedež',
      seats: 'sedežev',
      ownerOnly: 'Samo lastnik',
      accessLocalOnly: 'Dostop samo lokalno',
      accessRemote: 'Oddaljeni dostop',
      licensedApps: 'Aplikacije',
      licenceNeedsRegistration: 'Registrirajte ta strežnik zgoraj, da prejmete licenco iz oblaka.',
      licencePending: 'Čakanje, da oblak potrdi licenco tega strežnika — posodobi se samodejno v eni minuti.',
      licenceStale: 'Ni nedavno potrjeno',
      licenceStaleHint: 'Oblak že nekaj časa ni potrdil te licence — preverite povezavo zgoraj.',
      licenceGrantedTo: 'Dodeljeno',
      licenceConfirmed: 'Nazadnje potrjeno v oblaku',
      justNow: 'pravkar',
      minutesAgo: 'minut nazaj',
      hourAgo: 'uro nazaj',
      hoursAgo: 'ur nazaj',
      systemIcon: 'Sistemska ikona',
      systemIconType: 'Vrsta ikone',
      systemIconGenerated: 'Samodejno ustvarjeno',
      systemIconCustom: 'Slika po meri',
      systemIconColor: 'Barva ozadja',
      systemIconTextColor: 'Barva besedila',
      systemIconUpload: 'Naloži ikono',
      systemIconPreview: 'Predogled',
      systemIconSizeLimit: 'Samo PNG (največ 500KB)',
      systemIconSaved: 'Nastavitve sistemske ikone shranjene',
      saveSystemIconSettings: 'Shrani nastavitve sistemske ikone',
      systemIconReset: 'Ponastavi na privzeto',
      systemIconResetConfirm: 'Ponastaviti sistemsko ikono na privzeto?',
      systemIconResetDone: 'Sistemska ikona ponastavljena na privzeto',
      applianceUpdate: 'Posodobitev naprave',
      applianceUpdateDescription: `${brand.agentName} posodobitve programske opreme vozlišča in sistemskih paketov`,
      confirmInstallSystem:
        'Namestiti vse posodobitve sistemskih paketov? To lahko traja nekaj minut. Sistem bo še naprej deloval.',
      installAll: 'Namesti vse posodobitve',
      rollback: 'Povrni na prejšnjo različico',
      rollingBack: 'Povračanje...',
      upToDate: 'Sistem je posodobljen',
      updateInProgress: 'Posodobitev je v teku — vozlišče se bo ob koncu znova zagnalo.',
      // Hubov lastni poslušalec HTTPS (kartica `t_d653a49a`): par na disku in
      // stikalo, ki odloča, ali se streže. Stikalo tukaj je produktna površina
      // za `ssl_enabled` — odloča pred `.env` naprave; če nastavitev ni
      // zapisana, odloča `.env`; če ni ne enega ne drugega, odloča par — in
      // plošča pove, kdo je odločil.
      tlsTitle: 'Poslušalec HTTPS',
      tlsDescription:
        'Ta hub strežite po HTTPS z lastnim parom potrdila in zasebnega ključa. Katero stikalo je odločilo — nastavitev huba ali .env naprave — piše ob stanju.',
      tlsPairPresent: 'Par potrdila in ključa je nameščen',
      tlsPairAbsent: 'Para potrdila in ključa ni — po HTTPS se ne streže nič',
      tlsValidUntil: 'Veljavno do',
      tlsListenerLabel: 'Poslušalec',
      tlsStateOn: 'Vklopljen',
      tlsStateOff: 'Izklopljen',
      tlsSwitchOn: 'Vklopi',
      tlsSwitchOff: 'Izklopi',
      tlsSwitching: 'Preklapljam …',
      tlsSwitchedOn: 'HTTPS je vklopljen',
      tlsSwitchedOff: 'HTTPS je izklopljen — http:// so edina vrata tega huba',
      tlsSwitchedOnNoPair: 'Vklopljeno, a na disku ni para potrdila in ključa — še nič se ne streže',
      tlsDecidedBySettings: 'odloča nastavitev tega huba (ssl_enabled)',
      tlsDecidedByEnv: 'odloča .env naprave (ssl_enabled)',
      tlsDecidedByPair: 'odloča par potrdila in ključa na disku',
      tlsUploadTitle: 'Naloži par potrdila in ključa',
      tlsCertFile: 'Potrdilo (.crt/.pem)',
      tlsKeyFile: 'Zasebni ključ (.key/.pem)',
      tlsUpload: 'Naloži',
      tlsUploading: 'Nalagam …',
      tlsUploaded: 'Par je shranjen — spodnje stanje kaže, kaj hub počne zdaj',
      tlsUploadFailed: 'Nalaganje ni uspelo',
      tlsLoadFailed: 'Stanja poslušalca ni bilo mogoče prebrati',
      tlsSwitchFailed: 'Poslušalca ni bilo mogoče preklopiti',
    },

    settingsUsers: {
      usersManagement: 'Ljudje in naprave',
      peopleSectionTitle: 'Ljudje',
      peopleSectionHint: 'Osebe v tem vozlišču. Oseba se prijavi s svojim računom Torik — lokalnega gesla ni.',
      peopleEmpty: 'V tem vozlišču še ni nikogar. Prvo osebo povabite po e-pošti.',
      serverOwnerRow: 'Lastnik tega strežnika',
      accountLinked: 'Povezan z {email}',
      accountNotLinkedWithEmail: 'Račun še ni povezan — {email}',
      accountNotLinked: 'Račun še ni povezan',
      addUser: 'Dodaj uporabnika',
      inviteUser: 'Povabi uporabnika',
      inviteDescription:
        'Pošljite povabilo po e-pošti. Oseba ga sprejme, ko je prijavljena v svoj račun Torik — brez gesla in brez kode.',
      inviteRoleHint: 'V tem vozlišču dobijo vlogo {role}.',
      inviteEmail: 'E-poštni naslov',
      inviteName: 'Prikazno ime (neobvezno)',
      inviteNamePlaceholder: 'Janez Novak',
      inviteNameHint: 'Prikazano na seznamu oseb.',
      inviteCheck: 'Preveri račun',
      inviteChecking: 'Preverjam …',
      inviteAccountExists:
        'Ta naslov že ima račun Torik — oseba bo obveščena, strežnik pa je takoj v njeni aplikaciji.',
      inviteAccountAbsent:
        'Računa Torik še ni — oseba prejme povabilo za pridružitev. Strežnik se prikaže samodejno, ko bo račun pripravljen.',
      inviteCheckUnavailable: 'Oblaka ni bilo mogoče vprašati — povabilo lahko vseeno pošljete.',
      inviteRole: 'Vloga',
      roleResident: 'Stanovalec',
      roleGuest: 'Gost',
      roleAdmin: 'Administrator',
      // Nameščevalec je uporabnik v oblaku z urami, ne koda (kartica `t_2f0c4a91`).
      roleInstaller: 'Monter',
      // Ure, v katerih se ta oseba lahko prijavi — kar je zamenjalo kodo za
      // nameščevalca.
      accessWindowTitle: 'Ure dostopa',
      accessWindowHint:
        'Ure, v katerih se ta oseba lahko prijavi; preveri jih vozlišče samo — na spletu in ko je hiša brez povezave. Pustite prazno za brez omejitve.',
      accessWindowFrom: 'Od',
      accessWindowUntil: 'Do',
      accessWindowProblem: 'Začetek mora biti pred koncem.',
      inviteSend: 'Pošlji povabilo',
      inviteSending: 'Pošiljanje ...',
      inviteSent: 'Povabilo poslano',
      inviteNotSent: 'Povabilo ustvarjeno — povezavo delite ročno',
      inviteFailed: 'Povabila ni bilo mogoče ustvariti',
      inviteShareLink: 'Ta hub ne more pošiljati e-pošte — delite to povezavo:',
      inviteCopyLink: 'Kopiraj',
      inviteCopied: 'Kopirano',
      usersLoading: 'Nalaganje uporabnikov...',
      done: 'Končano',
      passwordNotAvailable:
        'Ta račun se prijavi s svojim računom Torik ali s pooblastilom za vključitev — lokalnega gesla ni.',
      editPersonTitle: 'Uredi osebo',
      deviceListTitle: 'Povezane naprave',
      deviceLastSeen: 'Nazadnje videno {date}',
    },

    settingsBackup: {
      title: 'Varnostno kopiranje in obnovitev',
      automaticBackupSettings: 'Nastavitve samodejnega varnostnega kopiranja',
      createBackup: 'Ustvari varnostno kopijo',
      creatingBackup: 'Ustvarjanje...',
      backupCreated: 'Varnostna kopija uspešno ustvarjena',
      backupFailed: 'Ustvarjanje varnostne kopije ni uspelo',
      configurationOnlyInfo:
        'Te varnostne kopije vsebujejo samo konfiguracijo. Predstavnostne datoteke, posnetki kamer, slike kamer in zgodovina beleženih vrednosti so izključeni.',
      settingsSaved: 'Nastavitve varnostnega kopiranja so shranjene',
      settingsLoadFailed: 'Nalaganje nastavitev varnostnega kopiranja ni uspelo',
      settingsSaveFailed: 'Shranjevanje nastavitev varnostnega kopiranja ni uspelo',
      backupBeforeUpgrade: 'Ustvari kopijo pred nadgradnjo',
      backupBeforeUpgradeDesc:
        'Pred namestitvijo programske posodobitve se samodejno ustvari varnostna kopija konfiguracije.',
      weeklyEnabled: 'Omogoči tedenske varnostne kopije',
      weeklyEnabledDesc: 'Vsak teden ustvari varnostno kopijo konfiguracije po spodnjem urniku.',
      weeklyDay: 'Dan kopiranja',
      weeklyTime: 'Čas kopiranja',
      keepBackupsCount: 'Število kopij na strežniku',
      keepBackupsCountHelp: 'Starejše lokalne datoteke varnostnih kopij se po ustvarjanju novih samodejno izbrišejo.',
      destinationSettings: 'Cilji varnostne kopije',
      networkCopyEnabled: 'Kopiraj varnostno kopijo na omrežno lokacijo',
      networkCopyEnabledDesc:
        'Po ustvarjanju lokalne strežniške kopije se ista datoteka kopira v omrežno mapo ali priklopljen omrežni delež.',
      networkBackupPath: 'Omrežna pot za kopije',
      networkBackupPathPlaceholder: '\\\\nas\\otto\\backups ali /mnt/backups/otto',
      networkBackupPathHelp:
        'Uporabite dosegljivo pot UNC ali priklopljeno mapo. Lokalna hramba na strežniku še vedno velja samo za strežniško mapo z varnostnimi kopijami.',
      cloudStorageTitle: 'Shramba v oblaku za naročnike',
      cloudStorageDesc: 'Shramba v oblaku za naročnike bo uporabljala isti paket varnostne kopije konfiguracije.',
      cloudStorageComingSoon:
        'Nalaganje v oblak še ni aktivno. Omogočeno bo, ko bo na voljo končna točka za naročniške varnostne kopije.',
      localRetentionNote:
        'Ročne varnostne kopije uporabljajo isti konfiguracijski paket in enako nastavitev lokalne hrambe.',
      availableBackups: 'Razpoložljive varnostne kopije',
      noBackups: 'Ni razpoložljivih varnostnih kopij',
      download: 'Prenesi',
      delete: 'Izbriši',
      deleteBackup: 'Izbriši varnostno kopijo',
      confirmDeleteBackup: 'Ali ste prepričani, da želite izbrisati to varnostno kopijo?',
      backupDeleted: 'Varnostna kopija izbrisana',
      restoreFromBackup: 'Obnovi iz varnostne kopije',
      warning:
        'Opozorilo: Obnovitev iz varnostne kopije bo prepisala vse trenutne podatke. Sistem se bo po obnovitvi znova zagnal.',
      selectBackupFile: 'Izberite datoteko varnostne kopije za obnovitev',
      restoringBackup: 'Obnavljanje...',
      restoring: 'Obnavljanje...',
      validating: 'Preverjanje...',
      backupRestored: 'Varnostna kopija uspešno obnovljena',
      restoreFailed: 'Obnovitev varnostne kopije ni uspela',
      confirmRestore: 'To bo prepisalo vse trenutne podatke. Nadaljujem?',
      confirmRestoreTitle: 'Potrdi obnovitev',
      validationWarnings: 'Opozorila',
      backupInfo: 'Podatki o varnostni kopiji',
      backupVersion: 'Različica',
      backupDate: 'Datum',
      incompatibleWarning: 'Shema podatkovne baze ni združljiva. Obnovitev lahko povzroči napake ali izgubo podatkov.',
      restoreInitiated: 'Obnovitev se je začela. Sistem se bo kmalu ponovno zagnal.',
      filename: 'Ime datoteke',
      created: 'Ustvarjeno',
      fileSize: 'Velikost datoteke',
      downloadBackup: 'Prenesi varnostno kopijo',
      selectFile: 'Izberi datoteko',
      deleteConfirm: 'Izbrišem {filename}?',
      downloadFailed: 'Prenos ni uspel',
      acceptedFormats: '.otto_backup, .ottohome_backup, .1hub_backup',
      restoreWizardStep1: 'Izberi datoteko varnostne kopije',
      restoreWizardStep2: 'Preglej varnostno kopijo',
      restoreWizardStep3: 'Možnosti obnove',
      restoreWizardStep4: 'Potrdi obnovitev',
      restoreWizardCrossServerBanner: 'Ta varnostna kopija je z drugega strežnika.',
      restoreWizardCrossServerInfo:
        'Uporabniška gesla uporabljajo bcrypt in so prenosljiva. Obstoječi uporabniki se lahko prijavijo s svojimi gesli. Strežnik se bo po obnovitvi znova zagnal - nato se boste morali ponovno prijaviti.',
      restoreWizardCreateRecoveryAdmin: 'Ustvari obnovitvenega skrbnika',
      restoreWizardRecoveryUsername: 'Skrbniško uporabniško ime',
      restoreWizardRecoveryPassword: 'Skrbniško geslo',
      restoreWizardRecoveryAdminDesc: 'Zagotovi, da po obnovitvi med strežniki deluje vsaj en skrbniški račun.',
      restoreWizardPreserveHubId: 'Ohrani trenutno identiteto strežnika',
      restoreWizardPreserveHubIdDesc: 'Prepreči prepis enoličnega ID-ja tega strežnika (priporočeno).',
      restoreWizardSummaryDb: 'Podatkovna baza bo zamenjana z vsebino varnostne kopije.',
      restoreWizardSummaryFiles: 'Naložene datoteke, podatki Matter in sistemske slike bodo obnovljeni.',
      restoreWizardFinalWarning: 'Strežnik se bo po obnovitvi znova zagnal. Vsi povezani uporabniki bodo odjavljeni.',
      restoreWizardUserCount: '{count} uporabniških računov v varnostni kopiji',
      restoreWizardTableCount: '{count} tabel podatkovne baze v varnostni kopiji',
      restoreWizardRestoreButton: 'Obnovi varnostno kopijo',
      restoreWizardRestoring: 'Obnavljanje varnostne kopije...',
      restoreWizardUploading: 'Nalaganje datoteke varnostne kopije...',
      restoreWizardRestoreComplete: 'Obnovitev je končana!',
      restoreWizardRestarting: 'Sistem se znova zaganja. Čez {seconds} sekund boste preusmerjeni na prijavno stran...',
      restoreWizardContinue: 'Nadaljuj',
      restoreWizardBack: 'Nazaj',
      restoreWizardValidating: 'Preverjanje datoteke varnostne kopije...',
      restoreWizardValidationFailed: 'Preverjanje datoteke varnostne kopije ni uspelo.',
      valuesBackupTitle: 'Varnostna kopija vrednosti',
      valuesBackupDesc:
        'Varnostno kopira zgodovino vrednosti naprav (analogni dnevniki, dnevniki števcev, dnevniki vrednosti). Datoteka se prenese neposredno in ni shranjena na strežniku.',
      exportValuesBackup: 'Izvozi kopijo vrednosti',
      exportingValues: 'Izvoz varnostne kopije vrednosti...',
      valuesRestoreTitle: 'Obnovi vrednosti',
      valuesRestoreDesc: 'Obnovite zgodovino vrednosti iz prejšnje datoteke varnostne kopije vrednosti.',
      valuesRestoreInfo:
        'Uvozijo se samo vrstice z ujemajočimi se vrednostmi naprav. Vrednosti neobstoječih naprav se preskočijo. To je združevanje - obstoječi podatki ostanejo ohranjeni.',
      selectValuesBackup: 'Izberi datoteko varnostne kopije vrednosti',
      importingValues: 'Uvoz varnostne kopije vrednosti...',
      valuesRestoreResult: 'Vrednosti obnovljene: {inserted} vstavljenih, {skipped} preskočenih',
      valuesRestoreFailed: 'Obnovitev varnostne kopije vrednosti ni uspela',
    },

    settingsAgent: {
      configuration: 'Konfiguracija',
      voice: 'Glas',
      enableAgent: 'Omogoči agenta',
      enableAgentDesc: 'Aktivirajte AI agenta, da vam pomaga z glasovnimi ukazi in avtomatizacijo pametnega doma.',
      wakeWord: 'Aktivacijska beseda',
      wakeWordDesc: `Izberite glasovni ukaz, ki aktivira agenta (npr. "Hey ${brand.agentName}", "OK Nabu").`,
      voiceDesc: 'Izberite svoje priljubljeni glas za odgovore agenta.',
      autoListen: 'Samodejno poslušanje',
      autoListenDesc: 'Samodejno začnite poslušati po odgovoru agenta, kar omogoča neprekinjeno pogovor.',
      confirmActions: 'Potrdi dejanja',
      confirmActionsDesc: 'Zahtevajte potrditev uporabnika pred izvršitvijo avtomatiziranih ukazov.',
      settings: 'Nastavitve',
      saving: 'Shranjevanje...',
      voiceServices: 'Glasovne storitve',
      browserServices: 'Brskalnik in avtomatizacija',
    },

    settingsDevices: {
      searchDevices: 'Iščite naprave...',
    },

    settingsDangerZone: {
      dangerZone: 'Nevarno območje',
      deleteAllRooms: 'Izbriši vse sobe',
      deleteAllRoomsDesc: 'Trajno izbriši vse sobe in njihove konfiguracije. Tega dejanja ni mogoče razveljaviti.',
      deleteAllDevices: 'Izbriši vse naprave',
      deleteAllDevicesDesc: 'Trajno izbriši vse naprave in njihove nastavitve. Tega dejanja ni mogoče razveljaviti.',
      deleteAllIntegrations: 'Izbriši vse integracije',
      deleteAllIntegrationsDesc: 'Prekine in izbriši vse integracije. Tega dejanja ni mogoče razveljaviti.',
      deleteAllScenes: 'Izbriši vse scene',
      deleteAllScenesDesc: 'Trajno izbriši vse scene in avtomatizacijo. Tega dejanja ni mogoče razveljaviti.',
      factoryReset: 'Tovarniško ponastavitev',
      warning: 'Opozorilo: Tega dejanja ni mogoče razveljaviti.',
      resetting: 'Ponastavljam...',
    },

    settingsLogs: {
      title: 'Sistemski dnevniki',
      logRetention: 'Čiščenje dnevnikov',
      logRetentionDescription:
        'Samodejno briši stare zapise iz dnevniških tabel. Nastavi koliko dni naj se podatki hranijo.',
      valueLogsRetention: 'Dnevnik vrednosti',
      scriptExecutionLogRetention: 'Dnevnik skript',
      presenceEventsRetention: 'Dogodki prisotnosti',
      intercomCallsRetention: 'Intercom klici',
      notificationsRetention: 'Obvestila',
      eventsRetention: 'Dogodki sistema',
      sceneExecutionsRetention: 'Izvajanja scen',
      messagesRetention: 'Sporočila',
      days: 'dni',
      saveLogRetention: 'Shrani nastavitve čiščenja',
      cleanNow: 'Počisti zdaj',
      cleaning: 'Čiščenje...',
      cleanNowConfirm: 'Ste prepričani? Stari zapisi bodo trajno izbrisani.',
      logRetentionSaved: 'Nastavitve čiščenja dnevnikov shranjene',
      logCleanupDone: 'Čiščenje končano: izbrisanih {count} zapisov',
      saving: 'Shranjevanje...',
    },

    settingsPlatform: {
      title: 'Platforma',
      storage: 'Shramba',
      dockerEngine: 'Pogon',
      dockerCli: 'CLI',
      hardwareDescription: 'Strojni profil platforme in stanje GPIO',
      testHardware: 'Preizkusi strojno opremo',
      hardwareTest: 'Preizkus strojne opreme',
      hardwareTestDescription: 'Nadzoruj sistemsko LED in simuliraj pritiske gumbov za testiranje.',
      ledCurrent: 'Trenutno stanje LED',
      cancel: 'Prekliči',
      close: 'Zapri',
      timeConfiguration: 'Nastavitve časa',
      timezone: 'Časovni pas',
      loadingTimezones: 'Nalaganje časovnih pasov...',
      ntpServers: 'NTP strežniki',
      ntpPlaceholder: 'ntp.example.com, pool.ntp.org',
      ntpDescription: 'Seznam strežnikov NTP, ločenih s vejicami. Pustite prazno za privzete strežnike.',
      saveTimeSettings: 'Shrani nastavitve časa',
      timeSettingsSaved: 'Nastavitve časa uspešno shranjene',
      refresh: 'Osveži',
      refreshing: 'Osveževanje...',
      daemon: 'Demon platforme',
      noUrlConfigured: 'URL ni konfiguriran',
      version: 'Različica',
      uptime: 'Čas delovanja',
      profile: 'Profil',
      mode: 'Način',
      mock: 'Simulacija',
      hardwareMode: 'Strojna oprema',
      hardware: 'Strojna oprema',
      gpioConfigured: 'GPIO konfiguriran',
      mockGpio: 'Simuliran GPIO',
      systemLed: 'Sistemska LED',
      fan: 'Ventilator',
      capabilities: 'Zmožnosti',
      ledState: 'Stanje LED',
      apply: 'Uporabi',
      applying: 'Uporabljam...',
      buttonPress: 'Pritisk gumba',
      buttonShort: 'Kratek',
      buttonMedium: 'Srednji',
      buttonLong: 'Dolg',
      buttonVeryLong: 'Zelo dolg',
      simulate: 'Simuliraj',
      simulating: 'Simuliranje...',
      host: 'Gostitelj',
      hostname: 'Ime gostitelja',
      runtime: 'Izvajalno okolje',
      systemUptime: 'Čas delovanja sistema',
      memory: 'Pomnilnik',
      temperature: 'Temperatura',
      loadAverage: 'Povprečna obremenitev',
      dockerServices: 'Docker storitve',
      available: 'Na voljo',
      unavailable: 'Ni na voljo',
      restart: 'Znova zaženi',
      restarting: 'Ponovni zagon...',
      noContainersReported: 'Ni prijavljenih vsebnikov.',
      power: 'Napajanje',
      enabled: 'Omogočeno',
      disabled: 'Onemogočeno',
      platform: 'Platforma',
      command: 'Ukaz',
      requesting: 'Pošiljanje zahteve...',
      reboot: 'Ponovni zagon',
      shutdown: 'Izklop',
      events: 'Dogodki',
      noEventsReported: 'Ni prijavljenih dogodkov.',
      loadingStatus: 'Nalaganje stanja',
      notConfigured: 'Ni konfigurirano',
      connected: 'Povezano',
      disconnected: 'Nepovezano',
      none: 'Brez',
      na: 'n/a',
      noStatus: 'Ni stanja',
      of: 'od',
      running: 'deluje',
      unknown: 'Neznano',
      ledBooting: 'Zagon',
      ledHealthy: 'Deluje',
      ledDegraded: 'Poslabšano',
      ledOffline: 'Brez povezave',
      ledUpdating: 'Posodabljanje',
      ledError: 'Napaka',
      ledFactoryResetPending: 'Tovarniška ponastavitev v čakanju',
      ledUnknown: 'Neznano',
      confirmRestart: 'Znova zagnati {name}?',
      confirmReboot: 'Znova zagnati gostitelja?',
      confirmShutdown: 'Izklopiti gostitelja?',
      se: {
        mode: 'Način',
        type: 'Tip',
        notFound: 'Ni najdeno',
        error: 'Napaka',
        title: 'Varni element',
        description: 'Strojni kriptografski soprocesor za certificiranje Matter',
        serial: 'Serijska številka',
        i2C: 'Vodilo I²C',
        provisioned: 'Zagotovljeno',
        present: 'Prisoten',
        yes: '✓ Da',
        no: 'Še ne',
      },
      monitoring: {
        title: 'Sistemski nadzor',
        description:
          'Nastavite opozorila za pragove zasedenosti diska. Ob doseženih mejah se skrbnikom pošljejo obvestila.',
        alerts: 'Opozorila',
        diskWarning: 'Prag opozorila za disk',
        diskCritical: 'Kritični prag za disk',
        save: 'Shrani nastavitve nadzora',
        diskUsage: 'Disk',
        offlineNotice:
          'Demon platforme je brez povezave — pragovi so lahko lokalne nadomestne vrednosti in jih ni mogoče shraniti.',
      },
      network: {
        title: 'Omrežje',
        description: 'Upravljanje omrežnih vmesnikov, WiFi in imena gostitelja',
        hostname: 'Ime gostitelja',
        gateway: 'Privzeti prehod',
        gatewayShort: 'GW',
        dns: 'Strežniki DNS',
        backend: 'Backend',
        default: 'Privzeto',
        noInterfaces: 'Ni prijavljenih vmesnikov.',
        connectSsid: 'WiFi SSID',
        ssidPlaceholder: 'Poišči ali vnesi SSID',
        password: 'Geslo',
        passwordPlaceholder: 'Geslo za WiFi',
        scan: 'Poišči',
        scanning: 'Iskanje...',
        connect: 'Poveži',
        connecting: 'Povezovanje...',
        saveHostname: 'Shrani ime gostitelja',
        resetDhcp: 'Ponastavi žično povezavo na DHCP',
        resetting: 'Ponastavljanje...',
        error: 'Napaka',
        confirmHostname:
          'Spremeniti ime gostitelja v {hostname}? To lahko vpliva na dostop mDNS (npr. {hostname}.local).',
        confirmResetDhcp: 'Ponastaviti žični vmesnik na DHCP? To lahko spremeni naslov IP.',
        configure: 'Konfiguriraj',
        static: 'Statični IP',
        dhcp: 'DHCP',
        methodLabel: 'Metoda',
        ipConfig: 'Konfiguracija IP',
        ipAddress: 'Naslov IP',
        prefix: 'Predpona',
        dnsDescription: 'Strežniki DNS, ločeni z vejico.',
        dhcpDescription: 'Vmesnik bo samodejno pridobil naslov IP, prehod in DNS iz omrežja.',
        confirmStatic: 'Nastaviti {iface} na statični IP ({address})? Povezava bo za kratek čas prekinjena.',
        confirmDhcp: 'Nastaviti {iface} na DHCP? Povezava bo za kratek čas prekinjena.',
        wifi: 'WiFi',
        wired: 'Žično',
      },
      saving: 'Shranjevanje...',
    },

    integrationCameras: {
      loadingState: 'Nalaganje kamer...',
      camerasTab: 'Kamere',
      devicesTab: 'Naprave',
      settingsTab: 'Nastavitve',
      logsTab: 'Dnevniki',
      statusConnected: 'Povezano',
      statusReady: 'Pripravljeno',
      nvr: {
        serverSection: 'Delite to vozlišče (strežnik NVR)',
        serverSectionHint: `Druga vozlišča ${brand.platformCompact} se lahko povežejo sem in gledajo kamere, ki jim jih dodelite.`,
        connectionInfo: 'Podatki o povezavi',
        hubUrl: 'URL vozlišča (uporabljen kot glavni URL na drugem vozlišču)',
        newClient: 'Nov odjemalec',
        clientName: 'Ime odjemalca',
        createClient: 'Ustvari',
        enabled: 'Omogočeno',
        disabled: 'Onemogočeno',
        clientsTitle: 'Odjemalci (druga vozlišča)',
        noClients: 'Ni še odjemalcev — ustvarite enega, da dobite enkratni žeton.',
        tokenTitle: 'Enkratni žeton odjemalca',
        tokenHint: 'Prilepite ta žeton v drugo vozlišče pri dodajanju vira NVR. Prikaže se samo enkrat.',
        close: 'Zapri',
        assignedCameras: 'Dodeljene kamere',
        saveAssignment: 'Shrani kamere',
        lastSeen: 'Nazadnje videno',
        neverSeen: 'Nikoli povezano',
        deleteClient: 'Izbriši',
        remoteClient: 'Oddaljeno',
        sourceSection: 'Druga vozlišča (viri NVR)',
        sourceSectionHint:
          'Dodajte vozlišče, ki z vami deli kamere, nato uvozite njegove kamere. Uvožene kamere so tanki odjemalci — snemanje poteka na izvornem vozlišču.',
        addSource: 'Dodaj vir',
        sourceName: 'Ime',
        masterUrl: 'URL vozlišča',
        masterUrlHint:
          'Osnovni URL drugega vozlišča, npr. https://my-hub. Njegov API je dosegljiv pod /api — sprejeta sta tako https://my-hub kot https://my-hub/api.',
        token: 'Žeton',
        test: 'Preveri',
        testOk: 'Dosegljivo',
        testFail: 'Neuspešno',
        showCameras: 'Prikaži kamere',
        importSelected: 'Uvozi izbrane',
        noRemoteCameras: 'To vozlišče vam še ni dodelilo nobene kamere.',
        remoteCamerasTitle: 'Kamere, ki so na voljo na izvornem vozlišču',
        importedTitle: 'Uvoženo na tem vozlišču',
        noImported: 'Ni še uvoženih kamer.',
        remove: 'Odstrani',
        removeAll: 'Odstrani vse',
        sync: 'Sinhroniziraj',
        adminRequired: 'Samo skrbniki lahko upravljajo souporabo NVR.',
        error: 'Nastavitev souporabe NVR ni bilo mogoče naložiti.',
      },
      nvrTab: 'NVR',
    },

    integrationDatapoints: {
      backButton: 'Nazaj na integracije',
      pageTitle: 'Podatkovne točke',
      loadingState: 'Nalaganje podatkovnih točk...',
      statusConnected: 'Povezano',
      statusDisconnected: 'Prekinjeno',
      errorMessage: 'Nalaganje podatkovnih točk ni uspelo',
    },

    integrationHomeAssistant: {
      entitiesTab: 'Entitete',
      devicesTab: 'Naprave',
      settingsTab: 'Nastavitve',
      logsTab: 'Dnevniki',
      loadingState: 'Nalaganje podatkov Home Assistant...',
      errorMessage: 'Povezava s Home Assistant ni uspela',
    },
    settingsTorikApi: {
      cancel: 'Prekliči',
      title: 'Torik API',
      subtitle: 'REST + WebSocket API, združljiv s Home Assistant, za zunanja orodja in povezave med vozlišči.',
      refresh: 'Osveži',
      running: 'API strežnik deluje',
      stopped: 'API strežnik ustavljen',
      port: 'Vrata',
      clients: 'Povezani odjemalci',
      tokenCount: 'Aktivni žetoni',
      enabled: 'Omogočeno',
      enabledToast: 'Torik API omogočen',
      disabledToast: 'Torik API onemogočen',
      endpoints: 'Končne točke',
      authHint: `Preverjanje pristnosti z "Authorization: Bearer ***" (WebSocket: {'{'}"type":"auth","access_token":"<token>"{'}'}).`,
      tokensTitle: 'Žetoni za dostop',
      tokensHint: 'Dolgoživi žetoni nosilca. Ustvarite enega tukaj in ga prilepite v vozlišče, ki se povezuje.',
      newToken: 'Nov žeton',
      noTokens: 'Ni še API žetonov.',
      lastUsed: 'nazadnje uporabljen',
      never: 'nikoli',
      active: 'Aktivno',
      disabled: 'Onemogočeno',
      delete: 'Izbriši',
      deleteConfirm: 'Izbrisati ta žeton? Odjemalci, ki ga uporabljajo, takoj izgubijo dostop.',
      deleted: 'Žeton izbrisan',
      createTitle: 'Ustvari API žeton',
      tokenCreatedTitle: 'Žeton ustvarjen',
      tokenName: 'Ime žetona',
      tokenNamePlaceholder: 'npr. sekundarno vozlišče, Node-RED',
      creating: 'Ustvarjanje...',
      create: 'Ustvari',
      copyWarning: 'Kopirajte ta žeton zdaj — prikaže se samo enkrat.',
      copy: 'Kopiraj',
      copied: 'Žeton kopiran',
      copyFailed: 'Kopiranje ni uspelo',
      done: 'Končano',
    },

    integrationKNX: {
      statusDisabled: 'Onemogočeno',
      statusConnected: 'Povezano',
      statusDisconnected: 'Prekinjeno',
      statusNotConfigured: 'Ni konfigurirano',
      configIssueTitle: 'Integracija ni konfigurirana',
      configIssueKnxMissingAddress:
        'Naslov prehoda KNX ni nastavljen, zato se integracija ne more povezati. V razdelku Nastavitve povezave vnesite IP naslov vmesnika KNX IP in shranite.',
      configIssueGeneric: 'Manjkajo zahtevane nastavitve povezave. Izpolnite spodnje nastavitve in shranite.',
      configIssuePaused: 'Samodejno ponovno povezovanje je ustavljeno, dokler nastavitve niso shranjene.',
      missingAddressWarning:
        'Naslov prehoda ni nastavljen — KNX se ne more povezati, dokler naslova ne vnesete in shranite.',
      // Serijski TP-UART2 (kartica t_1f38250b): izbira transporta, seznam vrat, UART in napredne možnosti
      serialTitle: 'Serijski TP-UART2',
      serialTransportLabel: 'Serijski prenos',
      serialTransportDirect: 'Neposredno na tej napravi',
      serialTransportDirectHint: 'Hub sam odpre serijska vrata in neposredno komunicira prek TP-UART2. Priporočeno.',
      serialTransportDaemon: 'Prek platformskega demona',
      serialTransportDaemonHint: 'Ohranite otto-platformd kot serijski transport (združljivostni način).',
      serialTransportOwnershipHint:
        'Serijska vrata lahko odpre le en proces: pri izbiri Neposredno mora biti transport KNX TP-UART v otto-platformd na tem sistemu IZKLOPLJEN.',
      serialPortLabel: 'Serijska vrata',
      serialPortRefresh: 'Osveži',
      serialPortsLoading: 'Nalaganje serijskih vrat…',
      serialPortsUnavailable: 'Hub ni vrnil seznama serijskih vrat — vnesite pot do naprave ročno.',
      serialPortsEmpty: 'Najdenih ni bilo nobenih serijskih vrat — vnesite pot do naprave ročno.',
      serialPortInUse: 'v uporabi',
      serialBaudRateLabel: 'Hitrost prenosa',
      serialParityLabel: 'Pariteta',
      serialParityNone: 'Brez',
      serialParityEven: 'Soda',
      serialParityOdd: 'Liha',
      serialDataBitsLabel: 'Podatkovni biti',
      serialStopBitsLabel: 'Stop biti',
      serialCrc16Label: 'Preverjanje CRC16 telegramov',
      serialCrc16Hint: 'Dodaj in preveri CRC16 pri prejetih telegramih. Na voljo samo pri hitrosti 19200.',
      serialAdvancedTitle: 'Napredno',
      serialEopTimeoutLabel: 'Časovna omejitev EOP (ms)',
      serialEopTimeoutHint:
        'Tišina, ki zaključi telegram (konec paketa). Podatkovni list TP-UART2 določa 2–2,5 ms — pustite privzeto vrednost 2,5.',
      serialMaxSendRetriesLabel: 'Poskusi pošiljanja',
      serialMaxSendRetriesHint: 'Kolikokrat se telegram ponovno pošlje, ko ga čip ne potrdi.',
      serialKeepAliveLabel: 'Interval vzdrževanja povezave (ms)',
      serialKeepAliveHint: 'Kako pogosto se preveri stanje povezave s čipom, da serijska povezava ostane aktivna.',
      serialCommandTimeoutLabel: 'Časovna omejitev ukaza (ms)',
      serialCommandTimeoutHint: 'Kako dolgo se čaka na potrditev čipa, preden se telegram ponovi.',
      serialPhysicalAddressRequired: 'Za serijske (TP-UART2) povezave je fizični naslov obvezen.',
      // Vmesnik KNX/IP (kartica t_17c8d635): omogočen tudi v serijskem načinu, z živim prikazom stanja
      ipServerTitle: 'Prehod KNX/IP (strežnik)',
      ipServerEnableLabel: 'Omogoči strežnik IP tunela',
      ipServerEnableHint:
        '{agent} deluje kot strežnik KNXnet/IP, tako da se lahko drugi odjemalci (ETS, vizualizacije) povežejo nanj.',
      ipServerListenPortLabel: 'Vrata poslušanja',
      ipServerMaxSessionsLabel: 'Največ sej (neobvezno)',
      ipServerEtsHint:
        'Hub na teh vratih ponuja celoten KNX/IP tunel — ETS se lahko poveže, spremlja vodilo in programira naprave prek njega. Deluje v tunelskih načinih in pri serijskem (neposredni TP-UART2) načinu.',
      ipServerStatusTitle: 'Stanje vmesnika',
      ipServerStatusRefresh: 'Osveži',
      ipServerStatusChecking: 'Preverjanje …',
      ipServerStatusListening: 'Posluša',
      ipServerStatusNotListening: 'Ne posluša',
      ipServerStatusUnavailable: 'Stanje ni na voljo',
      ipServerStatusNotListeningHint:
        'Hub poroča, da vmesnik ne posluša. Shranite nastavitve in preverite, da je integracija KNX povezana.',
      ipServerStatusUnavailableHint:
        'Ta hub ni odgovoril na zahtevo za stanje vmesnika, zato stanja tukaj ni mogoče prikazati.',
      ipServerSessionClient: 'Odjemalec',
      ipServerSessionChannel: 'Kanal',
      ipServerSessionSince: 'Od',
      ipServerNoSessions: 'Trenutno ni povezanih odjemalcev.',
      // Oddaljeni dostop izvajalca (kartica t_d51acc6a): potek z namizno aplikacijo + živi prikaz sej
      remoteAccessTitle: 'Oddaljeni dostop ETS',
      remoteAccessIntro:
        'Izvajalec zažene namizno aplikacijo otto-knx-link, se prijavi v oblak Torik in se prek aktivne seje oddaljene podpore poveže s tem hubom — nato ETS upravlja to vodilo prek lokalnega vmesnika na njegovem računalniku. Na tem objektu ni treba odpreti nobenih vhodnih vrat.',
      remoteAccessHowTitle: 'Kako deluje',
      remoteAccessHowStep1: 'Na računalnik izvajalca (Windows) namestite namizno aplikacijo otto-knx-link.',
      remoteAccessHowStep2: 'Prijavite se z računom izvajalca v oblaku Torik.',
      remoteAccessHowStep3: 'Povežite aplikacijo s tem hubom — dostop poteka prek aktivne seje oddaljene podpore.',
      remoteAccessHowStep4: 'V ETS se povežite na vmesnik KNXnet/IP na naslovu {address}.',
      remoteAccessEtsAddressLabel: 'Naslov za povezavo v ETS',
      remoteAccessDownloadPending: 'Povezava za prenos aplikacije bo prikazana, ko bo izdana prva različica.',
      remoteAccessPrereqTitle: 'Preden začnete',
      remoteAccessPrereqHub: 'Ta hub je povezan in integracija KNX deluje.',
      remoteAccessPrereqHubNotConnected:
        'Integracija KNX trenutno ni povezana — ETS bi dosegel ta hub, ne pa vodila.',
      remoteAccessPrereqHubDisabled: 'Integracija KNX je onemogočena.',
      remoteAccessPrereqSessionActive: 'Aktivna seja oddaljene podpore omogoča dostop ({name}).',
      remoteAccessPrereqSessionNone:
        'Nobena seja ni aktivna. Ustvarite jo v Nastavitve → Oddaljena podpora in izberite to integracijo.',
      remoteAccessPrereqWindow: 'Časovno okno seje je odprto — zapre se čez {remaining}.',
      remoteAccessPrereqWindowClosed: 'Nobeno časovno okno seje ni odprto.',
      remoteAccessWhoTitle: 'Kdo ima trenutno dostop',
      remoteAccessWhoDesc:
        'Seja imenovanemu izvajalcu omogoča dostop do vodila te integracije, dokler je njeno okno odprto. Ko sejo zaključite, se povezava prekine.',
      remoteAccessWhoEmpty: 'Na tej integraciji ni aktivne seje oddaljene podpore.',
      remoteAccessWhoCreatedBy: 'Ustvaril {name}',
      remoteAccessWhoExpiresIn: 'zapre se čez {remaining}',
      remoteAccessManage: 'Upravljanje oddaljene podpore',
      remoteAccessRefresh: 'Osveži',
      remoteAccessLoading: 'Nalaganje …',
      remoteAccessUnavailable: 'Hub ni odgovoril na seznam sej, zato oddaljenega dostopa tukaj ni mogoče preveriti.',
      remoteAccessNoInstaller: 'Izvajalec ni določen',
      deleteAllDevicesButton: 'Izbriši vse naprave',
      loadingState: 'Nalaganje KNX podatkov...',
      settingsTab: 'Nastavitve',
      datapointsTab: 'Podatkovne točke',
      devicesTab: 'Naprave',
      groupMonitorTab: 'Skupinski monitor',
      busMonitorTab: 'Bus monitor',
      logsTab: 'Dnevniki',
      remoteAccessTab: 'Oddaljeni dostop',
      deleteModalTitle: 'Izbriši vse KNX naprave',
      deleteConfirmMessage:
        'Ali ste prepričani, da želite izbrisati vse KNX naprave? Tega dejanja ni mogoče razveljaviti.',
      deleteConfirmLabel: 'Za potrditev vnesite "DELETE" spodaj:',
      deleteConfirmPlaceholder: 'Vnesite DELETE za potrditev',
      cancelButton: 'Prekliči',
      deleteConfirmButton: 'Izbriši vse naprave',
      deletingState: 'Brisanje naprav...',
      errorMessage: 'Obdelava KNX zahteve ni uspela',
    },

    remoteSupport: {
      selectIntegration: 'Izberi KNX integracijo',
      selectIntegrationPlaceholder: 'Izberi KNX integracijo...',
      knxRemoteSupport: 'KNX oddaljena podpora',
      tpuartTitle: 'Potreben gonilnik TP-UART',
      tpuartDesc: 'Deljenje KNX vmesnika preko TP-UART gonilnika bo na voljo, ko ga bo platformni demon podpiral.',
      remoteUsers: 'Uporabniki oddaljene podpore',
      remoteUsersDesc:
        'Upravljajte uporabnike, ki lahko nudijo oddaljeno podporo. Dodajte uporabnike po e-pošti in nastavite časovne omejitve dostopa.',
      addUserByEmail: 'Dodaj uporabnika po e-pošti',
      emailPlaceholder: "uporabnik{'@'}primer.si",
      addUser: 'Dodaj',
      adding: 'Dodajanje...',
      remove: 'Odstrani',
      removing: 'Odstranjevanje...',
      installerRole: 'Inštalater',
      noEmail: 'Ni e-pošte',
      noRemoteUsers: 'Ni dodanih uporabnikov oddaljene podpore.',
      editAccess: 'Uredi',
      day: 'Dan',
      days: 'Dni',
      daysAccess: 'dni dostopa',
      perSession: 'na sejo',
      unlimited: 'Neomejeno',
      unlimitedAccess: 'Neomejen dostop',
      confirmRemoveUser: 'Odstraniti {name} iz oddaljene podpore? Račun bo pretvorjen nazaj v navadnega uporabnika.',
      accessDaysPrompt: 'Trajanje dostopa (dni, 0 = neomejeno):',
      accessHoursPrompt: 'Največ ur na sejo:',
      newSession: 'Nova seja podpore',
      selectUser: 'Izberi uporabnika',
      selectUserPlaceholder: 'Izberi uporabnika...',
      timeWindow: 'Trajanje seje',
      createSession: 'Ustvari sejo',
      creating: 'Ustvarjanje...',
      endSession: 'Končaj sejo',
      ending: 'Končevanje...',
      activeSessions: 'Aktivne seje',
      installerLabel: 'Inštalater',
      timeRemaining: 'Preostali čas',
      expired: 'Poteklo',
      justNow: 'pravkar',
      ago: 'nazaj',
      hour: 'Ura',
      hours: 'Uri',
      minutes: 'Minut',
      send: 'Pošlji',
      messagePlaceholder: 'Vnesi sporočilo...',
      noMessages: 'Ni še sporočil.',
      issueReport: 'Prijava težave / Klepet',
      issueReportDesc: 'Sporočilo uporabniku podpore o težavi, na kateri se dela.',
      viewChat: 'Klepet',
      cannotAddSelf: 'Ne morete dodati sebe. Tako bi si zaklenili dostop do skrbniškega računa.',
    },

    integrationMatter: {
      loadingState: 'Nalaganje Matter podatkov...',
      settingsTab: 'Nastavitve',
      nodesTab: 'Vozlišča',
      devicesTab: 'Naprave',
      logsTab: 'Dnevniki',
      errorMessage: 'Povezava z Matter omrežjem ni uspela',
    },

    integrationMatterBridge: {
      brideDeviceCount: 'Mostene naprave',
      loadingState: 'Nalaganje podatkov Matter mostu...',
      bridgedDevicesTab: 'Mostene naprave',
      commissioningTab: 'Zagon',
      settingsTab: 'Nastavitve',
      logsTab: 'Dnevniki',
      errorMessage: 'Povezava z Matter mostom ni uspela',
    },

    integrationComputers: {
      subtitle: `Računalniki z nameščenim agentom ${brand.agentName}, povezani s tem vozliščem.`,
      integrationLabel: `${brand.platformCompact} računalniki`,
      refreshAction: 'Osveži',
      addComputerAction: 'Dodaj računalnik',
      totalLabel: 'Računalniki',
      onlineLabel: 'Na spletu',
      offlineLabel: 'Brez povezave',
      onlineState: 'Na spletu',
      offlineState: 'Brez povezave',
      connectedState: 'Povezan',
      noComputersState: 'Omogočeno, ni računalnikov',
      disabledState: 'Onemogočeno',
      unknownState: 'Neznano',
      loadingState: 'Nalaganje računalnikov…',
      emptyTitle: 'Ni še računalnikov',
      emptyMessage: `Namestite agent ${brand.agentName} na računalnik in ga povežite s tem vozliščem, da ga boste upravljali iz ${brand.platformName}.`,
      hostLabel: 'Gostitelj',
      platformLabel: 'Platforma',
      agentVersionLabel: 'Agent',
      lastSeenLabel: 'Nazadnje videno',
      neverSeen: 'Nikoli povezano',
      memoryLabel: 'Pomnilnik',
      diskLabel: 'Disk',
      tempLabel: 'Temperatura CPU',
      uptimeLabel: 'Čas delovanja',
      rebootAction: 'Znova zaženi',
      sleepAction: 'Mirovanje',
      shutdownAction: 'Izklop',
      wakeAction: 'Prebudi',
      wakeSendAction: 'Pošlji paket za prebujanje',
      wakeHint: 'Vozlišče pošlje paket za prebujanje iz svojega omrežja (WOL mora biti omogočen v BIOS-u računalnika).',
      removeAction: 'Odstrani',
      refreshNodeAction: 'Osveži stanje',
      macPlaceholder: 'AA:BB:CC:DD:EE:FF',
      loadError: 'Računalnikov ni bilo mogoče naložiti',
      refreshFailed: 'Osvežitev ni uspela',
      powerSent: 'Ukaz za napajanje poslan v',
      powerFailed: 'Ukaz za napajanje ni uspel',
      wakeSent: 'Paket za prebujanje poslan',
      wakeFailed: 'Prebujanje prek omrežja (WOL) ni uspelo',
      removeConfirmTitle: 'Odstraniti računalnik?',
      removeConfirmMessage: 'S tem prekinete povezavo računalnika s tem vozliščem in odstranite njegovo napravo.',
      removed: 'Računalnik odstranjen',
      removeFailed: 'Odstranitev ni uspela',
      addDialogTitle: 'Dodaj računalnik',
      addDialogSubtitle: `Ustvarite kodo za seznanjanje, nato na računalniku namestite agent ${brand.agentName} s to kodo. Koda poteče po 15 minutah.`,
      nodeNamePlaceholder: 'npr. Studio PC',
      generateTokenAction: 'Ustvari kodo za seznanjanje',
      copyTokenAction: 'Kopiraj',
      pairingCodeLabel: 'Koda za seznanjanje',
      installCommandTitle: 'Na računalniku zaženite:',
      doneAction: 'Končano',
      copied: 'Koda za seznanjanje kopirana',
      copyFailed: 'Kopiranje ni uspelo',
      pairingFailed: 'Kode za seznanjanje ni bilo mogoče ustvariti',
      macLabel: 'MAC',
      hubAddressLabel: 'Naslov vozlišča',
      hubAddressHint:
        'Naslov, ki ga bodo računalniki uporabili za dostop do tega vozlišča. Seznam prikazuje omrežne naslove tega vozlišča — izberite tistega, ki ga računalnik lahko doseže (npr. isto omrežje), ali vnesite naslov po meri. V produkciji (https) je naslov vozlišča prednastavljen.',
      commandCopied: 'Ukaz kopiran',
      computersTab: 'Računalniki',
      devicesTab: 'Naprave',
      customHubAddressAction: 'Naslov po meri...',
      customHubAddressPlaceholder: 'http://192.168.1.72',
      selectHubAddressHint: 'Izberite naslov vozlišča zgoraj, da vidite namestitvene ukaze.',
    },
    integrationTouchPanels: {
      integrationName: 'Touch paneli',
      statusDisabled: 'Onemogočeno',
      statusConnected: 'Povezano',
      statusReady: 'Pripravljeno',
      loadingState: 'Nalaganje integracije Touch panelov...',
      panelsTab: 'Paneli',
      devicesTab: 'Naprave',
      settingsTab: 'Nastavitve',
      logsTab: 'Dnevniki',
      refreshAction: 'Osveži',
      panelsAction: 'Paneli',
      settingsAction: 'Nastavitve',
      logsAction: 'Dnevniki',
      totalPanelsLabel: 'Registrirani paneli',
      onlinePanelsLabel: 'Trenutno povezani',
      offlinePanelsLabel: 'Brez povezave',
      sleepingPanelsLabel: 'V mirovanju',
      pairingStatusLabel: 'Stanje seznanjanja',
      pairedPanelsLabel: 'Seznanjeni',
      pendingPanelsLabel: 'Čakajoče seznanjanje',
      lastActivityLabel: 'Zadnja aktivnost',
      noActivityLabel: 'Ni nedavne aktivnosti',
      noActivityDescription: 'Noben panel še ni sporočil aktivnosti',
      attentionLabel: 'Potrebuje pozornost',
      justNowLabel: 'pravkar',
      minutesAgoLabel: 'pred {count} min',
      hoursAgoLabel: 'pred {count} h',
      daysAgoLabel: 'pred {count} d',
      errorMessage: 'Integracije Touch panelov ni bilo mogoče naložiti',
    },

    integrationZigbee: {
      loadingState: 'Nalaganje Zigbee podatkov...',
      nodesTab: 'Vozlišča',
      devicesTab: 'Naprave',
      settingsTab: 'Nastavitve',
      errorMessage: 'Povezava z Zigbee omrežjem ni uspela',
    },

    integrationZWave: {
      loadingState: 'Nalaganje Z-Wave podatkov...',
      nodesTab: 'Vozlišča',
      networkTab: 'Omrežje',
      devicesTab: 'Naprave',
      settingsTab: 'Nastavitve',
      errorMessage: 'Povezava z Z-Wave omrežjem ni uspela',
    },
    integrationWled: {
      segmentsTab: 'Segmenti',
      devicesTab: 'Naprave',
      settingsTab: 'Nastavitve',
      logsTab: 'Dnevniki',
      loadingState: 'Nalaganje...',
      errorMessage: 'Integracije ni bilo mogoče naložiti',
    },

    integrationHue: {
      lightsTab: 'Luči',
      groupsTab: 'Skupine',
      devicesTab: 'Naprave',
      settingsTab: 'Nastavitve',
      logsTab: 'Dnevniki',
    },
    integrationUnifi: {
      networkTab: 'Omrežje',
      devicesTab: 'Naprave',
      settingsTab: 'Nastavitve',
      logsTab: 'Dnevniki',
    },
    integrationSomfy: {
      gatewayTab: 'Prehod',
      devicesTab: 'Naprave',
      settingsTab: 'Nastavitve',
      logsTab: 'Dnevniki',
    },
    integrationSynology: {
      statusTab: 'Stanje',
      devicesTab: 'Naprave',
      settingsTab: 'Nastavitve',
      logsTab: 'Dnevniki',
    },
    integrationMediaPlayers: {
      playersTab: 'Predvajalniki',
      devicesTab: 'Naprave',
      sourcesTab: 'Viri',
      settingsTab: 'Nastavitve',
    },
    integrationSonos: {
      settingsTab: 'Nastavitve',
      playersTab: 'Predvajalniki',
      devicesTab: 'Naprave',
    },
    integrationSpotify: {
      settingsTab: 'Nastavitve',
      devicesTab: 'Naprave',
    },

    panelPairing: {
      title: `${brand.agentName} Dotikalna plošča`,
      subtitle: 'Nastavitev naprave',
      discoverTitle: `Poiščite svoje ${brand.agentName} vozlišče`,
      discoverDescription: `Iskanje vašega lokalnega omrežja za ${brand.agentName} vozliščem...`,
      scanningStatus: 'Skeniranje omrežja...',
      noHubsFound: 'Ni samodejno najdenih vozlišč.',
      manualEntryHint: 'Ročno vnesite naslov vozlišča spodaj.',
      manualEntryLabel: 'Ali ročno vnesite',
      ipAddressPlaceholder: 'IP naslov vozlišča',
      portPlaceholder: 'Vrata',
      connectButton: 'Poveži',
      rescanButton: '↻ Skeniraj znova',
      backButton: 'Nazaj',
      connectedToLabel: 'Povezano z',
      pairingMethodTitle: 'Seznanite to napravo',
      pairingRequirement: `Administrator mora generirati kodo za seznanjanje v aplikaciji ${brand.agentName}.`,
      enterPinButton: 'Vnesite PIN',
      pinEntryTitle: 'Vnesite PIN za seznanjanje',
      pinEntryDescription: `Vnesite 6-mestni PIN, prikazan v aplikaciji ${brand.agentName} admin.`,
      pairDeviceButton: 'Seznani napravo',
      pairingInProgress: 'Seznanjanje...',
      invalidPinError: 'Neveljaven PIN. Poskusite znova.',
      cameraAccessDenied: 'Dostop do kamere zavrnjen. Omogočite dovoljenja za kamero.',
      invalidQrError: 'Neveljavna QR koda. Poskusite znova.',
      scanQrButton: 'Skenirajte kodo za seznanjanje',
      scanQrTitle: 'Skenirajte kodo',
      qrHint:
        'Uperite kamero v kodo, prikazano v aplikaciji — kodo za seznanjanje plošče ali kodo naprave iz zaslona »Povežite napravo«.',
      qrScanning: 'Iščem kodo …',
      exitPinTitle: 'Nastavite izhodni PIN',
      exitPinDescription: 'Izberite 4-mestni PIN za kasnejši izhod iz načina plošče.',
      skipButton: 'Preskoči',
      pairedSuccess: 'Naprava seznanjena!',
      connectingMessage: 'Povezovanje z vašo ploščo...',
    },

    playPairing: {
      title: `${brand.agentName} Play`,
      subtitle: 'Nastavitev naprave',
      discoverTitle: `Poiščite svoje ${brand.agentName} vozlišče`,
      discoverDescription: `Iskanje vašega lokalnega omrežja za ${brand.agentName} vozliščem...`,
      scanningStatus: 'Skeniranje omrežja...',
      noHubsFound: 'Ni samodejno najdenih vozlišč.',
      manualEntryHint: 'Ročno vnesite naslov vozlišča spodaj.',
      manualEntryLabel: 'Ali ročno vnesite',
      ipAddressPlaceholder: 'IP naslov vozlišča',
      portPlaceholder: 'Vrata',
      connectButton: 'Poveži',
      rescanButton: '↻ Skeniraj znova',
      backButton: 'Nazaj',
      connectedToLabel: 'Povezano z',
      pairingMethodTitle: 'Seznanite to napravo',
      pairingRequirement: `Administrator mora generirati kodo za seznanjanje v aplikaciji ${brand.agentName}.`,
      enterPinOption: 'Vnesite PIN',
      enterPinDescription: 'Vnesite 6-mestno kodo, prikazano v admin aplikaciji',
      scanQrOption: 'Skeniraj QR kodo',
      scanQrDescription: 'Skenirajte QR kodo, prikazano v admin aplikaciji',
      pinEntryTitle: 'Vnesite PIN za seznanjanje',
      pinEntryDescription: `Vnesite 6-mestni PIN, prikazan v aplikaciji ${brand.agentName} admin.`,
      pairDeviceButton: 'Seznani napravo',
      pairingInProgress: 'Seznanjanje...',
      scanQrTitle: 'Skeniraj QR kodo',
      scanQrInstruction: `Usmerite kamero v QR kodo v aplikaciji ${brand.agentName} admin.`,
      scanningAutoStatus: 'Samodejno skeniranje...',
      exitPinTitle: 'Nastavite izhodni PIN',
      exitPinDescription: 'Izberite 4-mestni PIN za kasnejši izhod iz načina Play.',
      confirmPinButton: 'Potrdi PIN',
      reenterPinInstruction: 'Ponovno vnesite svoj PIN za potrditev',
      pinMismatchError: 'PIN-a se ne ujemata. Poskusite znova.',
      skipButton: 'Preskoči',
      pairedSuccess: 'Naprava seznanjena!',
      pairedDescription: `Ta naprava je zdaj povezana z vašim ${brand.agentName} vozliščem kot Play naprava.`,
      startPlayModeButton: 'Zaženi način Play',
      invalidPinError: 'Neveljaven PIN. Poskusite znova.',
      cameraAccessDenied: 'Dostop do kamere zavrnjen. Omogočite dovoljenja za kamero.',
      invalidQrError: 'Neveljavna QR koda. Poskusite znova.',
    },

    gallery: {
      pageTitle: 'Fotografije',
      emptyTitle: 'Še ni fotografij',
      emptyDescription: 'Naložite fotografije in videe, da začnete svojo osebno galerijo v oblaku.',
      noAlbumTitle: 'Še ni albumov',
      noAlbumDescription: 'Ustvarite album, da združite in delite svoje fotografije.',
      noAlbumItems: 'V tem albumu še ni fotografij',
      newAlbum: 'Nov album',
      takePhoto: 'Fotoaparat',
      uploadPhotos: 'Naloži',
      createAlbumTitle: 'Ustvari album',
      selectPhotos: 'Izberi',
      uploadProgress: 'Nalaganje',
      dropZoneText: 'Spustite fotografije in videe sem',
      uploadStatus: 'datoteka',
      uploadStatusPlural: 'datotek',
      sharedBadge: 'V skupni rabi',
      publicBadge: 'Javno',
    },

    reminders: {
      pageTitle: 'Opomniki',
      addButton: 'Nov opomnik',
      upcomingTab: 'Prihodnji',
      completedTab: 'Končani',
      emptyUpcoming: 'Ni prihodnjih opomnikov.',
      emptyCompleted: 'Ni končanih opomnikov.',
      createReminderTitle: 'Nov opomnik',
      editReminderTitle: 'Uredi opomnik',
      titleLabel: 'Naslov',
      titlePlaceholder: 'Kupi živila',
      notesLabel: 'Opombe',
      notesPlaceholder: 'Dodatne podrobnosti...',
      notesOptional: '(izbirno)',
      dateTimeLabel: 'Datum in čas',
      repeatLabel: 'Ponavljanje',
      repeatNone: 'Brez',
      repeatDaily: 'Dnevno',
      repeatWeekly: 'Tedensko',
      repeatMonthly: 'Mesečno',
      repeatWeekdays: 'Delavniki (pon–pet)',
      cancelButton: 'Prekliči',
      saveButton: 'Shrani',
      createButton: 'Ustvari opomnik',
    },

    timers: {
      pageTitle: 'Časovniki',
      addButton: 'Nov časovnik',
      emptyState: 'Še ni časovnikov. Dotaknite se Nov časovnik za začetek.',
      createTimerTitle: 'Nov časovnik',
      labelLabel: 'Oznaka',
      labelPlaceholder: 'Voda za testenine',
      durationLabel: 'Trajanje',
      hoursLabel: 'Ure',
      minutesLabel: 'Minute',
      secondsLabel: 'Sekunde',
      soundLabel: 'Zvok',
      totalLabel: 'skupaj',
      startButton: 'Zaženi',
      pauseButton: 'Premor',
      resetButton: 'Ponastavi',
      deleteButton: 'Izbriši',
      deleteConfirm: 'Izbrisati ta časovnik?',
      cancelButton: 'Prekliči',
      createButton: 'Ustvari',
      creatingLabel: 'Ustvarjanje...',
      statusIdle: 'nedejavno',
      statusRunning: 'teče',
      statusPaused: 'premor',
      statusCompleted: 'končano',
    },
    integrationESPHome: {
      entitiesTab: 'Vozlišča in entitete',
      devicesTab: 'Naprave',
      settingsTab: 'Nastavitve',
      logsTab: 'Dnevniki',
      loadingState: 'Nalaganje podatkov ESPHome...',
      errorMessage: 'Nalaganje integracije ESPHome ni uspelo',
    },
    integrationTorik: {
      entitiesTab: 'Uvoz',
      devicesTab: 'Naprave',
      settingsTab: 'Povezava',
      logsTab: 'Dnevniki',
      loadingState: 'Nalaganje povezave Torik vozlišča...',
      entitiesTitle: 'Oddaljene naprave',
      entitiesHint:
        'Odkrijte naprave na povezanem vozlišču in jih uvozite kot lokalne naprave. Vrednosti ostanejo sinhronizirane, ukazi pa se posredujejo.',
      discover: 'Odkrij naprave',
      discovering: 'Odkrivanje...',
      searchPlaceholder: 'Iščite po imenu ali ID-ju entitete...',
      selectAll: 'Izberi vse',
      selected: 'izbranih',
      importCount: 'Uvozi',
      imported: 'Uvoženo',
      emptyState: 'Pritisnite Odkrij naprave, da prenesete naprave iz povezanega vozlišča.',
      importTitle: 'Uvozi oddaljene naprave',
      roomMapping: 'Preslikaj oddaljene sobe v lokalne sobe:',
      remoteRoom: 'Oddaljena soba:',
      noRoom: '— Brez sobe (samodejno ujemanje po imenu) —',
      created: 'Ustvarjeno',
      skipped: 'Izpuščeno',
      errors: 'Napake',
      close: 'Zapri',
      cancel: 'Prekliči',
      import: 'Uvozi',
      importing: 'Uvažanje...',
      linkTitle: 'Povezava vozlišča',
      linkHint: 'Povezava z povezanim Torik vozliščem (njegov Torik API).',
      test: 'Preveri povezavo',
      testing: 'Preverjanje...',
      sync: 'Sinhroniziraj zdaj',
      syncing: 'Sinhronizacija...',
      syncDone: 'Sinhronizacija končana',
      reconnect: 'Ponovno poveži',
      reconnecting: 'Ponovno povezovanje...',
      reconnectDone: 'Ponovno povezano',
      cleanup: 'Odstrani vse uvožene naprave',
      cleaning: 'Odstranjujem...',
      cleanupConfirm: 'Odstraniti vse naprave, uvožene iz tega vozlišča? Tega ni mogoče razveljaviti.',
      cleanupDone: 'Odstranjene naprave',
      peerUrl: 'URL partnerja',
      peerVersion: 'Različica partnerja',
      token: 'Žeton za dostop',
    },

    // Stran Lokalno (`views/LocalServers.vue`): vozlišča v tem omrežju in
    // tista, shranjena na tej napravi. Novi nizi so tu; starejše besedilo
    // strani je napisano v njenem lastnem slogu (`utils/consoleText.ts`).
    //
    // `join`/`joinHint`/`joinUnsupported` tu niso več: gumb za pridružitev in
    // njegova kodna površina sta zapustila to stran (kartica `t_c890ce4c`, D3).
    // Ostaja tisto, kar kartica brez poti noter pove o vozlišču.
    //
    // `ownedByAnother` je odstranjen (načrt `LOCAL-FIRST-CONNECT.md` §2/D3,
    // 24. 9. 2026): niz "{hub} pripada nekomu drugemu …" je trdil dejstvo, ki ga
    // aplikacija ni ugotovila — izbran je bil le iz krajevnih podatkov (vozlišče
    // se je predstavilo, ni prevzemljivo, ta naprava nima ničesar). Povedal je
    // lastniku, da njegovo lastno vozlišče pripada nekomu drugemu.
    // Gostujoča izkušnja demo hiše (kartica `t_803e86a4`): značka z imenom
    // obiskovalca v zgornji vrstici in enovrstični pas pod njo. Prijavna stran
    // (D10) pred preusmeritvijo zapiše `demo_guest`; aplikacija ga prebere
    // (`composables/useDemoGuest.ts`), o vsem skupaj pa odloči vloga `viewer`.
    demoGuest: {
      pill: 'Gost',
      pillNamed: 'Gost · {name}',
      hint: 'To je demo dom — cel dan je simuliran v nekaj minutah.',
      dismiss: 'Skrij',
    },
    localServers: {
      hubNotIdentified: 'Ni se predstavilo (starejša programska oprema)',
      unclaimedHere: 'Vozlišča {hub} še nihče ne poseduje — za prevzem odprite aplikacijo Torik.',
      holdsNothingFor:
        'Vozlišče {hub} je dosegljivo, ta naprava pa nima ničesar, kar bi ga odprlo. Če je vaš račun Torik na tem vozlišču, ga odprite med svojimi strežniki — sicer prosite skrbnika, da doda vaš račun.',
    },
    launcher: {
      localHint:
        'To vozlišče se odpre z vašim računom Torik — v tem omrežju, ko se tu odzove, prek varnega tunela, ko se ne. Odpre ga tudi poverilnica naprave, shranjena na tej napravi; geslo vozlišča ni potrebno in se ne shrani.',
    },
  },
  shell: {
    home: 'Domov',
    // The floor for a tab nothing else names (card t_99f5ed79) — see `en.ts`.
    newTab: 'Nov zavihek',
    closeTab: 'Zapri zavihek',
    alertError: 'Napaka',
    alertWarning: 'Opozorilo',
    alertNotice: 'Obvestilo',
    player: 'Predvajalnik',
    previous: 'Prejšnja',
    play: 'Predvajaj',
    pause: 'Premor',
    mute: 'Utišaj',
    unmute: 'Vklopi zvok',
    volume: 'Glasnost',
    // The main process's native popups (card t_99f5ed79): the tab context menu,
    // the app menu, and the connection-info dialog — see `en.ts` for the note.
    openInNewWindow: 'Odpri v novem oknu',
    connectionInfo: 'Podatki o povezavi',
    reload: 'Znova naloži',
    fullscreen: 'Celoten zaslon',
    close: 'Zapri',
    launcher: 'Zaganjalnik',
    services: 'Storitve',
    miniPlayerWindow: 'Mini okno predvajalnika',
    rebuildBar: 'Obnovi sistemsko vrstico',
    settings: 'Nastavitve',
    quit: 'Izhod',
    info: {
      target: 'Cilj',
      endpoint: 'Naslov',
      hubId: 'ID vozlišča',
      hubName: 'Ime vozlišča',
      state: 'Stanje',
      route: 'Pot',
      connected: 'povezano',
      disconnected: 'ni povezave',
      secure: 'varno',
      cloudHub: 'vozlišče v oblaku {id}',
      managedInLauncher: 'Poverilnice in shranjene strežnike urejate v zaganjalniku.',
      ok: 'V redu',
      tab: 'Zavihek',
    },
  },
  connectionLost: {
    title: 'Povezava je izgubljena',
    session: '{hub}: seja je potekla. Znova se povežite, da boste lahko delali naprej v tem zavihku.',
    offline: '{hub} se ne odziva. Preverite omrežje in se nato znova povežite.',
    thisServer: 'Ta strežnik',
    reconnect: 'Ponovno poveži',
    reconnecting: 'Ponovno povezovanje...',
    close: 'Zapri',
  },
  api: {
    // What a failed hub call actually means (`utils/apiFailure.ts`), so a surface
    // that only catches the error can still name the cause instead of one sentence
    // that fits every failure — read as `t(apiFailureSentenceKey(error))`.
    failure: {
      unreachable: 'Vozlišča ni bilo mogoče doseči, zato teh nastavitev ni bilo mogoče prebrati.',
      refused: 'To okno ni prijavljeno v vozlišče, zato je zavrnilo te nastavitve.',
      wrong_target: 'Odgovor ni prišel iz lastne storitve tega vozlišča, zato teh nastavitev ni bilo mogoče prebrati.',
      hub_failed: 'Vozlišče je med branjem teh nastavitev javilo napako.',
    },
  },
  hub: {
    // Adopting an unclaimed hub from the app (HEADLESS-HUB-ONBOARDING.md
    // D3/D4/D5): the confirm sheet, the sticker QR and every refusal the hub
    // can answer with — one sentence each, in every shipped locale.
    adopt: {
      title: 'Prevzemite to vozlišče',
      intro:
        'To vozlišče je v vašem omrežju in še nima lastnika. S prevzemom se registrira v vaš račun Torik in postanete njegov lastnik.',
      // Odgovor vozlišča ni bil `true` (načrt `LOCAL-FIRST-CONNECT.md` §2/D3):
      // vozlišče je že prevzeto ali pa ni odgovorilo. Pove, kaj se je zgodilo in
      // katere poti obstajajo — nikoli, kdo ga poseduje, tega aplikacija ne ve.
      notOffered:
        'To vozlišče ne čaka na prevzem, zato tu ni česa prevzeti. Nič ni bilo poslano — če je vaš račun Torik na tem vozlišču, ga odprite med svojimi strežniki.',
      hubLabel: 'Vozlišče',
      accountLabel: 'Račun',
      roleLabel: 'Vaša vloga',
      roleOwner: 'Lastnik',
      noCode: 'Ničesar ni treba vtipkati — vaš račun je poverilnica.',
      noAccount: 'Niste prijavljeni',
      // Seja, za katero ta list ne pozna imena računa: naprava JE prijavljena,
      // zato vrstica ne sme trditi drugega (kartica t_a53c5f61).
      accountSignedIn: 'Prijavljeni ste',
      signInRequired: 'Za prevzem tega vozlišča se prijavite v svoj račun Torik.',
      signIn: 'Prijava',
      signingIn: 'Odpiram …',
      signInFailed: 'Prijave ni bilo mogoče začeti. Poskusite znova.',
      confirm: 'Prevzemi to vozlišče',
      working: 'Prevzemam …',
      retry: 'Poskusi znova',
      cancel: 'Prekliči',
      doneTitle: 'Vozlišče {hub} je vaše',
      doneBody: 'Registrirano je v račun {account}, ta naprava pa je zdaj povezana z njim.',
      // Različica zgornjega stavka brez imena računa: `{account}` v vseh jezikih
      // ne more nositi fraze, zato se ta primer izrazi sam.
      doneBodySignedIn: 'Registrirano je v vaš račun Torik, ta naprava pa je zdaj povezana z njim.',
      doneWhere: 'Najdete ga med svojimi strežniki, na domači strani.',
      roleLine: 'V tem vozlišču imate vlogo {role}.',
      continue: 'Nadaljuj',
      scanLead: 'Novo vozlišče? Skenirajte kodo, natisnjeno na njegovi škatli — s tem ga prevzamete v svoj račun.',
      linkWrongHub: 'Ta koda pripada drugemu vozlišču od tistega, ki se odziva na tem naslovu. Nič ni bilo prevzeto.',
      linkUnverified:
        'Vozlišče na tem naslovu ni potrdilo, katero vozlišče je, zato ni bilo nič prevzeto. Preverite, ali je vozlišče vklopljeno in dosegljivo.',
      rateLimited: 'Preveč poskusov s te naprave. Počakajte minuto in poskusite znova.',
      notOnHubNetwork:
        'Vozlišče je zavrnilo: ta naprava ni v omrežju vozlišča. Povežite se v isto omrežje kot vozlišče (ne prek VPN) in poskusite znova.',
      alreadyClaimed: 'To vozlišče že ima lastnika. Prosite ga, da vas povabi.',
      invalidCloudToken: 'Seja vašega računa Torik je bila zavrnjena. Prijavite se znova in nato prevzemite.',
      invalidDevice: 'Vozlišče je zavrnilo ključ te naprave. Poskusite znova.',
      cloudUnreachable:
        'Vozlišče ni moglo doseči oblaka Torik, zato se ni moglo registrirati. Preverite internetno povezavo vozlišča in poskusite znova.',
      hubIdentityUnavailable: 'Vozlišče še ne more prebrati svoje identitete. Počakajte trenutek in poskusite znova.',
      registrationFailed:
        'Oblak ni hotel registrirati vozlišča v vaš račun. Poskusite znova ali se obrnite na podporo.',
      unsupported: 'To vozlišče ne podpira prevzema (starejša programska oprema).',
      unreachable: 'Na tem naslovu se ni nihče odzval. Preverite, ali je vozlišče vklopljeno in v tem omrežju.',
      unproven:
        'Naprava na tem naslovu ni mogla dokazati, da je to vozlišče. Nič ni bilo prevzeto in vaš račun ji ni bil poslan.',
      malformed: 'Vozlišče je odgovorilo brez prevzema. Nič ni bilo spremenjeno.',
      refused: 'Vozlišče je prevzem zavrnilo.',
      cardAction: 'Nezasedeno vozlišče — prevzamem?',
      cardHint:
        'Vozlišča {hub} še nihče ne upravlja. S prevzemom se registrira v vaš račun Torik in postanete njegov lastnik.',
      cardSignIn: 'Za prevzem vozlišča {hub} se prijavite v svoj račun Torik.',
      badgeWaiting: 'Čaka na prevzem',
      // Prevzem je dejanje površine za iskanje (načrt `LOCAL-FIRST-CONNECT.md`
      // §2/D3): pogovorno okno v zaganjalniku pove stanje vozlišča in nosi natanko
      // eno povezavo na površino, ki ga lahko prevzame — modalno okno Najdi
      // lokalne strežnike (`components/server/FindLocalServersModal.vue`, načrt
      // `HOME-ONLY-SERVER-CARDS.md` §3 C) — tam so dejstva vozlišča na zaslonu
      // poleg gumba.
      localPageHint:
        'Vozlišča {hub} še nihče ne upravlja — ni med vašimi strežniki: poiščite ga pod Najdi lokalne strežnike.',
      localPageAction: 'Najdi lokalne strežnike',
      addressLabel: 'Naslov',
      loopbackOnly:
        'Ta naprava doseže to vozlišče le na naslovu {address} — na njegovem lastnem računalniku. Vozlišče nikoli ne sprejme prevzema s samega sebe (od tam prihajajo tudi predorovani klici), zato ga prevzemite z druge naprave v istem omrežju.',
      tokenRetired:
        'Hub za prevzem ne sprejema več prijave z računom — potrebna je licenca. Posodobite aplikacijo in poskusite znova.',
      licenceUsed:
        'Ta licenca za prevzem je bila že porabljena. Nič ni bilo spremenjeno — poskusite znova, da dobite novo.',
      licenceExpired: 'Licenca za prevzem je potekla, preden jo je hub lahko uporabil. Poskusite znova.',
      licenceMismatch: 'Licenca je bila izdana za drug hub. Nič ni bilo prevzeto.',
      licenceInvalid:
        'Hub ni mogel preveriti licence, ki jo je podpisal oblak. Posodobite aplikacijo in hub ter poskusite znova.',
      licenceRequired:
        'Hub je pričakoval licenco za prevzem, poslane pa ni bilo nobene. Posodobite aplikacijo in poskusite znova.',
      licenceRefused: 'Oblak ni hotel izdati licence za prevzem tega huba.',
      licenceUnknownHub:
        'Oblak ni mogel prepoznati tega huba, zato ni izdal licence. Pustite, da hub enkrat doseže internet, in poskusite znova.',
      licenceAlreadyOwned: 'Ta hub že ima lastnika v drugem računu Torik. Prosite lastnika, naj vas povabi.',
      licenceUnavailable:
        'Oblak trenutno ne more izdajati licenc za prevzem. Poskusite pozneje ali se obrnite na podporo.',
      licenceUnauthorized: 'Seja vašega računa Torik je bila zavrnjena. Prijavite se znova in nato izvedite prevzem.',
      licenceUnreachable:
        'Oblaka Torik ni bilo mogoče doseči, zato licence ni bilo mogoče izdati. Preverite internetno povezavo te naprave in poskusite znova.',
      licenceMalformed: 'Oblak je odgovoril brez licence. Nič ni bilo prevzeto — poskusite znova.',
      password: {
        title: 'Nastavite lokalno geslo',
        intro:
          'Geslo za {hub} poskrbi, da hiša deluje tudi brez interneta — in da se lahko vsak v hiši prijavi, tudi ko oblak Torik ni dosegljiv.',
        label: 'Geslo',
        hint: 'Najmanj 8 znakov.',
        confirmLabel: 'Potrdite geslo',
        mismatch: 'Gesli se ne ujemata.',
        currentLabel: 'Trenutno geslo',
        save: 'Shrani geslo',
        saving: 'Shranjujem …',
        skip: 'Ne zdaj',
        done: 'Lokalno geslo je nastavljeno — hiša zdaj deluje tudi brez interneta.',
        noSessionNote:
          'Ta naprava na hubu ni prijavljena, zato lokalnega gesla ni bilo mogoče nastaviti. Odprite hub in ga nastavite tam.',
        resolving: 'Preverjam ta strežnik …',
        noAddress:
          'Ta strežnik nima naslova, ki bi ga ta naprava lahko poklicala, zato lokalnega gesla od tu ni mogoče nastaviti.',
        noAccount: 'Za nastavitev lokalnega gesla na tem hubu se prijavite v svoj račun Torik.',
        notThisAccount:
          'Ta hub pripada drugemu računu Torik, zato ta račun ne more nastaviti njegovega lokalnega gesla.',
        noAnswer:
          'Na naslovu tega huba se ni oglasil nihče, zato lokalnega gesla ni bilo mogoče nastaviti. Preverite, da je hub vklopljen in v tem omrežju.',
        close: 'Zapri',
        required: 'Vnesite geslo.',
        tooShort: 'Geslo je prekratko — najmanj 8 znakov.',
        tooLong: 'Geslo je predolgo (največ 72 bajtov).',
        wrongCurrent: 'To ni geslo, ki ga ta račun na hubu že ima.',
        notPermitted: 'To geslo lahko nastavi le skrbnik.',
        noSuchUser: 'Hub tega računa ne pozna.',
        noSession: 'Ta naprava na hubu ni prijavljena, zato gesla ne more nastaviti.',
        invalidCredentials: 'Napačno uporabniško ime ali geslo.',
        disabled: 'Ta račun je na tem hubu onemogočen.',
        // Okno, zavrnjeno tudi na lokalnih vratih (kartica `t_2f0c4a91`) — in
        // povedano ločeno od "onemogočen", kar je drugo dejstvo.
        outsideWindow:
          'Ta račun se lahko prijavi le v urah, nastavljenih v vozlišču. Prosite lastnika vozlišča, da okno prestavi.',
        tooManyAttempts: 'Preveč poskusov. Počakajte minuto in poskusite znova.',
        unreachable: 'Na tem naslovu se ni nihče odzval. Preverite, da je hub vklopljen in v tem omrežju.',
        refused: 'Hub je zavrnil nastavitev gesla.',
        removeNotPermitted: 'Lokalno geslo druge osebe lahko odstrani le skrbnik.',
        removeNoSession: 'Ta naprava na hubu ni prijavljena, zato gesla ne more odstraniti.',
        removeRefused: 'Hub ni želel odstraniti tega gesla.',
      },
    },
    join: {
      title: 'Pridružite se temu vozlišču',
      intro:
        'To vozlišče je v vašem omrežju in vaš račun Torik v njem že ima vlogo. S pridružitvijo se račun poveže s tem vozliščem in ta naprava ga lahko uporablja — brez kode in brez gesla.',
      hubLabel: 'Vozlišče',
      accountLabel: 'Račun',
      roleLabel: 'Vaša vloga',
      roleReading: 'Preverjam …',
      roleUnknown: 'Še ni znano',
      noCode:
        'Ničesar ni treba vnesti — vaš račun je poverilnica. Koda na zaslonu vozlišča je za goste, zunanje izvajalce in plošče brez tipkovnice.',
      noAccount: 'Niste prijavljeni',
      signInRequired: 'Za pridružitev temu vozlišču se prijavite v svoj račun Torik.',
      confirm: 'Pridruži se temu vozlišču',
      working: 'Pridružujem se …',
      retry: 'Poskusite znova',
      cancel: 'Prekliči',
      doneTitle: 'Pridružili ste se vozlišču {hub}',
      doneBody: '{account} je zdaj povezan s tem vozliščem in ta naprava ga lahko uporablja.',
      roleLine: 'Vaša vloga v tem vozlišču je {role}.',
      continue: 'Nadaljuj',
      noMatchingUser:
        'To vozlišče še nima uporabnika z vašim e-poštnim naslovom. Prosite lastnika vozlišča, da povabi ta naslov, in poskusite znova.',
      notAMember: 'Vaš račun Torik v tem vozlišču nima vloge. Prosite lastnika vozlišča, da povabi ta naslov.',
      userDisabled: 'Ta račun je v tem vozlišču onemogočen. Prosite lastnika vozlišča, da ga omogoči.',
      // Ure, v katerih se ta oseba lahko prijavi (kartica `t_2f0c4a91`):
      // nameščevalec je povabljen uporabnik v oblaku za obisk, to pa je zavrnitev,
      // na katero naleti, ko obisk pade izven okna, ki ga je nastavil lastnik.
      outsideLoginWindow:
        'Ta račun se lahko prijavi le v urah, ki jih je lastnik nastavil v vozlišču. Prosite ga, da okno prestavi.',
      invalidCloudToken: 'Seja vašega računa Torik je bila zavrnjena. Prijavite se znova in poskusite ponovno.',
      deviceInUse:
        'Ta naprava je že vgrajena pod drugim računom. Najprej jo tam prekličite ali uporabite drugo napravo.',
      alreadyClaimed:
        'To vozlišče je pravkar prevzelo to napravo — zahtevek je bil že porabljen. Znova odprite vozlišče.',
      expired: 'Zahtevek je potekel, preden ga je vozlišče prevzelo. Poskusite znova.',
      grantKeyMissing: 'Oblak Torik trenutno ne more podpisati dovoljenja za to napravo. Poskusite znova čez trenutek.',
      unknownDevice: 'Vozlišče ne pozna te vgradnje. Poskusite znova.',
      notApproved: 'Vozlišče še ni zabeležilo dovoljenja za to napravo. Poskusite znova čez trenutek.',
      invalidProof: 'Vozlišče je zavrnilo ključ te naprave. Poskusite znova.',
      rateLimited: 'Preveč poskusov s te naprave. Počakajte minuto in poskusite znova.',
      unreachable: 'Na tem naslovu se ni nihče odzval. Preverite, ali je vozlišče vklopljeno in v tem omrežju.',
      malformed: 'Vozlišče je odgovorilo, ne da bi povezalo to napravo. Nič ni bilo spremenjeno.',
      refused: 'Vozlišče je zahtevek zavrnilo. Nič ni bilo spremenjeno.',
      // Pot prek računa je za to osebo zaprta (kartica `t_6b11b40d`): vozlišče
      // nima uporabnika s tem naslovom, zato vodi naprej koda.
      useCode: 'Namesto tega uporabite kodo za vgradnjo',
    },
    // Vozlišče, ki ga ta aplikacija ne more odpreti (kartica `t_bfe0edc9`):
    // poved, čigava poverilnica manjka in kje je prava pot naprej za to osebo.
    // Bere jo `utils/hubOpenFallback.ts` prek `t(plan.messageKey)` — na strani
    // Lokalno, na zaslonu povezovanja v zavihku in v oknu izgubljene povezave
    // (`components/ConnectionLostOverlay.vue`, ki pokaže, kaj je ponovno
    // povezovanje zavrnilo) — to okno je površina zavihka vozlišča, zato so
    // povedi v vseh šestih katalogih, drugače kot `views.localServers.*`.
    open: {
      title: '{hub} se ni odprlo',
      dismiss: 'Skrij',
      openLocalPage: 'Najdi lokalne strežnike',
      openServers: 'Strežniki',
      // Strani vozlišča so bile tik pred tem, da se pokažejo brez poverilnice
      // za sabo: aplikacija pove dejstvo, namesto da bi narisala lupino.
      needsCredential:
        'Strani tega vozlišča potrebujejo poverilnico, ki je ta naprava nima. Nič ni bilo poslano in nič se ni spremenilo.',
      // Ena poved za vsak način, kako vozlišče ostane zaprto (`HUB_OPEN_FAILURES`).
      // Segment ključa je speljan tako kot vsaka pot ključa v tem repozitoriju —
      // `[A-Za-z0-9_]` (`KEY_SHAPE`, `locales/localeAudit.ts`) — zato zavrnitev,
      // katere lastno ime ima vezaje (`no-credential`), tukaj postane
      // `no_credential`; `hubOpenMessageKey()` je edini kraj tega prevoda.
      failure: {
        no_credential: 'Ta naprava še nima poverilnice za {hub}. Odpre ga vaš račun Torik — brez kode in brez gesla.',
        credential_refused:
          '{hub} ni sprejelo poverilnice te naprave, zato je bila zavržena. Odprite ga tukaj z računom Torik — koda ni potrebna.',
        no_cloud_session: 'Za odpiranje vozlišča {hub} se prijavite v svoj račun Torik.',
        no_lan_address: '{hub} ni sporočilo naslova, ki bi ga ta naprava lahko poklicala.',
        no_account_identity:
          'Vaš račun Torik še ne pozna vozlišča {hub}. Prevzemite ga tukaj ali prosite lastnika, da povabi ta naslov.',
        unreachable: 'Na naslovu {address} se ni nihče odzval. Preverite, ali je {hub} vklopljeno in v tem omrežju.',
        permission_held:
          'Brskalnik zadržuje to zahtevo: tej strani še ni dovoljen dostop do vašega lokalnega omrežja. Dovolite dostop do lokalnega omrežja in poskusite znova — ali odprite {hub} prek oblaka.',
        not_this_hub: 'Na naslovu {address} se je odzvalo nekaj, kar ni {hub}.',
        not_proven:
          '{hub} se je odzvalo na naslovu {address}, a ni dokazalo, da drži ključ, ki ga je pripel vaš račun. Nič ni bilo poslano.',
        cannot_prove: 'Naprave na naslovu {address} ni bilo mogoče vprašati, ali je res {hub}.',
        refused: '{hub} je zavrnilo zahtevek vašega računa Torik — prosite lastnika, da povabi ta naslov.',
        // Zavrnitev **oblaka** (`services/cloudSessionRefusal.ts`, načrt
        // FLOOR-PLAN-AND-PLAN-EDITOR.md §3.2/D3): pogoji vozlišča so samo lokalni.
        // Ni napaka — stanje strežnika, povedano enkrat, z edino potjo do spremembe.
        remote_access_not_licensed:
          'Ta strežnik je nastavljen na dostop samo lokalno — dosegljiv je iz svojega omrežja. Oddaljeni dostop je vključen v plačljiv paket strežnika.',
      },
      // Geslo samega vozlišča (načrt §2/C5–C6, odločitev lastnika D1): vrata, ki
      // ne potrebujejo oblaka, vpisana v pogovorno okno, ki ga odpre obvestilo
      // (`components/server/LocalPasswordModal.vue`). Zadnja dva stavka sta
      // zavrnitvi, ki jih skupni seznam ubesedi za *nastavljanje*.
      localPassword: {
        button: 'Odpri {hub} z lokalnim geslom',
        title: 'Lokalno geslo',
        intro:
          'Geslo, nastavljeno na samem vozlišču {hub}. Deluje tudi brez interneta — nič od tu se ne pošlje v oblak Torik.',
        identifier: 'Uporabniško ime ali e-pošta',
        password: 'Geslo',
        note: 'Shrani se le za to sejo — na tej napravi še ni shranjeno.',
        submit: 'Odpri {hub}',
        submitting: 'Odpiranje…',
        cancel: 'Prekliči',
        credentialsRequired: 'Vpišite svoje uporabniško ime in geslo.',
        refused: 'Vozlišče je to prijavo zavrnilo.',
      },
    },
    // Uvedba (načrt `LOCAL-SERVER-ONBOARDING-JOURNEY.md` §3/C2–C3, odločitve
    // lastnika §7 Q1/Q2/Q4): kaj stran Lokalno odpre za strežnik, ki je v tem
    // računu in katerega načrt ga ohranja v njegovem omrežju. Najprej stanje,
    // nato poštena poved o plačljivem načrtu in nazadnje lokalno geslo
    // (`hub.adopt.password.*` — korak, ki si ga deli s prevzemom). Nič tu ne
    // prodaja: brez cenika in brez nakupa, načrt je v računu.
    onboard: {
      title: 'Uvedba strežnika',
      intro:
        'Ta strežnik deluje v vašem omrežju. Tu sta stanje licence in geslo, ki poskrbi, da ostane dosegljiv tudi brez interneta.',
      licenceLabel: 'Licenca',
      reading: 'Berem …',
      remoteTitle: 'Oddaljeni dostop zahteva plačljiv načrt',
      remoteBody: 'Oddaljeni dostop do tega strežnika je del plačljivega načrta. Načrt uredite v svojem računu Torik.',
      accountLink: 'Uredi načrt v računu',
      accountHint: 'Odpre vaš račun Torik v brskalniku.',
      openButton: 'Uvedi {hub}',
      doneTitle: 'Strežnik {hub} je pripravljen',
      doneSkipped: 'Končano. Lokalno geslo lahko nastavite kadar koli na tej strani.',
      noAddress:
        'Ta strežnik ni sporočil naslova, s katerega bi ga ta naprava lahko dosegla, zato lokalnega gesla od tu ni mogoče nastaviti. Najprej ga odprite na seznamu strežnikov.',
    },
  },
  // WLED integration — the two tabs read these (WLEDSegmentsTab.vue, WLEDSettingsTab.vue)
  wled: {
    tabs: {
      segmentsTitle: 'Segmenti',
      segmentsSubtitle:
        'Vsak aktivni WLED segment je mogoče uvoziti kot svetlobno napravo (vključno z učinki, paletami in prednastavitvami).',
    },
    discover: 'Odkrij',
    discovering: 'Odkrivanje...',
    creating: 'Ustvarjanje...',
    createDevices: 'Ustvari svetlobne naprave',
    loading: 'Nalaganje segmentov...',
    emptyTitle: 'Ni najdenih segmentov',
    emptyMessage:
      'Pritisnite Odkrij, da preberete razporeditev segmentov s krmilnika WLED. Naprave se ustvarijo za vsak segment — privzeti krmilnik z enim trakom ima en segment, ki pokriva vse LED diode.',
    createHint: 'Ustvarite eno svetlobno napravo na segment (privzeto: vse).',
    loadFailed: 'Segmentov ni bilo mogoče naložiti',
    createFailed: 'Naprav ni bilo mogoče ustvariti',
    discoveryFailed: 'Odkrivanje ni uspelo',
    alreadyImported: 'Že uvoženi segmenti so bili izpuščeni. Nove luči se prikažejo pod Prostori / Naprave.',
    colName: 'Segment',
    colType: 'Tip',
    colColor: 'Barva',
    colEffect: 'Učinek',
    colPalette: 'Paleta',
    colStatus: 'Stanje',
    online: 'Na spletu',
    offline: 'Brez povezave',
    settings: {
      title: 'Nastavitve',
      subtitle: 'Nastavitve povezave za krmilnik WLED. Ena integracija upravlja en krmilnik.',
      connected: 'Povezano',
      disconnected: 'Prekinjeno',
      noUrl: 'URL krmilnika ni nastavljen',
      enabled: 'Omogočeno',
      disabled: 'Onemogočeno',
      reconnecting: 'Ponovno povezovanje...',
      reconnect: 'Ponovno poveži',
      boardTitle: 'Krmilnik',
      refresh: 'Osveži',
      name: 'Ime',
      version: 'Vdelana programska oprema',
      leds: 'LED diode',
      channels: 'Kanali',
      url: 'URL krmilnika',
      scanning: 'Skeniranje...',
      findOnNetwork: 'Poišči v omrežju',
      urlHint: 'IP naslov ali ime gostitelja krmilnika WLED — ali uporabite Poišči v omrežju.',
      apiKey: 'Ključ API',
      apiKeyPlaceholder: 'Neobvezno',
      hide: 'Skrij',
      show: 'Pokaži',
      apiKeyHint: 'Potreben je le, kadar je varnost WLED omogočena.',
      pollInterval: 'Interval osveževanja (sekunde)',
      pollHint: 'Nadomestno osveževanje, kadar WebSocket ni na voljo.',
      testing: 'Preizkušanje...',
      test: 'Preizkusi povezavo',
      saved: 'Nastavitve shranjene.',
      saving: 'Shranjevanje...',
      save: 'Shrani nastavitve',
      errorUpdate: 'Posodobitev integracije ni uspela',
      errorReconnect: 'Ponovno povezovanje ni uspelo',
      errorConnection: 'Povezava ni uspela',
      errorSave: 'Nastavitev ni bilo mogoče shraniti',
    },
  },

  // ── Aplikacija plošče: površina plošče, ki deluje ob aplikaciji ─────────────
  panelApp: {
    untitled: 'Plošča',
    roleLabel: 'Vloga',
    runsBeside: 'deluje ob vaši seji',
    close: 'Zapri ploščo',
    pairingTitle: 'Poveži to napravo s ploščo',
    pairingHint:
      'Na prijavljeni napravi odprite ploščo s seznama plošč ali vnesite kodo za povezovanje, ki jo prikaže.',
    pinLabel: 'Koda za povezovanje',
    pinPlaceholder: 'npr. 4K7-T2B',
    connect: 'Poveži',
    connecting: 'Povezovanje…',
    pairingFailed: 'Ta koda za povezovanje je bila zavrnjena.',
    noPages: 'Ta plošča še nima strani.',
    credentialAccepted: 'Poverilnica plošče je sprejeta',
    credentialRefused: 'Poverilnica plošče je zavrnjena',
    credentialUnknown: 'Preverjanje poverilnice plošče…',
    sessionNote: 'Vaš račun ostane prijavljen. Ta plošča je ločena površina s svojo poverilnico.',
    openOnThisDevice: 'Odpri na tej napravi',
    openOnThisDeviceHint: 'Prikaže to ploščo na tej napravi, ob aplikaciji, v katero ste prijavljeni.',
    openFailed: 'Te plošče ni bilo mogoče odpreti na tej napravi.',
    deviceModeTitle: 'Ta naprava',
    deviceModeHint:
      'Kaj ta naprava je — ne na čem deluje. Plošča ob zagonu prevzame zaslon; aplikacija odpre plošče v svojem oknu.',
    deviceModeApp: 'Uporabi kot aplikacijo',
    deviceModePanel: 'Uporabi kot ploščo',
    deviceModeSaved: 'Shranjeno za to napravo.',
  },
} as const;
